var royalcaninCatProducts = [
  // -- Kitten Dry Food --
  {
    image: '/pet_images/RC_Kitten_2kg.jpg',
    id: 'RC_Kitten_2kg',
    name: 'Royal Canin Kitten (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 368,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Growth Kitten Food is designed for kittens from 4 to 12 months old. Your playful and affectionate kitten deserves the best nutrition during this time of big changes, discoveries and new encounters!Key Benefits:Digestive Health:...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Growth Kitten Food</strong> is designed for kittens from 4 to 12 months old. </p><p>Your playful and affectionate kitten deserves the best nutrition during this time of big changes, discoveries and new encounters!</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Digestive Health: </strong>Supports digestion and healthy balance of intestinal flora, during this essential growth period.</li><li><strong>Immune System Support : </strong>Premium formula designed to support your kitten’s natural defences during this essential growth stage.</li><li><strong>Healthy Growth :</strong> An adapted content of protein, vitamins and minerals including vitamin D and calcium helps support the development of the kitten’s bones and muscles.</li><li><span><strong>L.I.P</strong> : </span><span>Selected protein with digestibility over 90%</span></li></ul></div><p><span>To be stored in a cool, dry place.</span></p>',
    keyBenefits: [
      'Digestive Health:',
      'Immune System Support :',
      'Healthy Growth :',
      'L.I.P',
    ],
    feedingGuide: [
      {
        weight: 'KITTEN\'S AGE',
        idealWeight: 'KITTEN\'S WEIGHT',
        overweight: 'DRY FOOD ONLY',
      },
      {
        weight: '1 - 2 months',
        idealWeight: '0.4 - 1 kg',
        overweight: '29 - 48 g',
      },
      {
        weight: '3 - 4 months',
        idealWeight: '1.3 - 2 kg',
        overweight: '61 - 66 g',
      },
      {
        weight: '5 - 6 months',
        idealWeight: '2.3 - 2.9 kg',
        overweight: '69 - 67 g',
      },
      {
        weight: '7 - 12 months',
        idealWeight: '3.1 - 4 kg',
        overweight: '64 - 51 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Kitten_4kg.jpg',
    id: 'RC_Kitten_4kg',
    name: 'Royal Canin Kitten (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 650,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Growth Kitten Food is designed for kittens from 4 to 12 months old. Your playful and affectionate kitten deserves the best nutrition during this time of big changes, discoveries and new encounters!Key Benefits:Digestive Health:...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Growth Kitten Food</strong> is designed for kittens from 4 to 12 months old. </p><p>Your playful and affectionate kitten deserves the best nutrition during this time of big changes, discoveries and new encounters!</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Digestive Health: </strong>Supports digestion and healthy balance of intestinal flora, during this essential growth period.</li><li><strong>Immune System Support : </strong>Premium formula designed to support your kitten’s natural defences during this essential growth stage.</li><li><strong>Healthy Growth :</strong> An adapted content of protein, vitamins and minerals including vitamin D and calcium helps support the development of the kitten’s bones and muscles.</li><li><span><strong>L.I.P</strong> : </span><span>Selected protein with digestibility over 90%</span></li></ul></div><p><span>To be stored in a cool, dry place.</span></p>',
    keyBenefits: [
      'Digestive Health:',
      'Immune System Support :',
      'Healthy Growth :',
      'L.I.P',
    ],
    feedingGuide: [
      {
        weight: 'KITTEN\'S AGE',
        idealWeight: 'KITTEN\'S WEIGHT',
        overweight: 'DRY FOOD ONLY',
      },
      {
        weight: '1 - 2 months',
        idealWeight: '0.4 - 1 kg',
        overweight: '29 - 48 g',
      },
      {
        weight: '3 - 4 months',
        idealWeight: '1.3 - 2 kg',
        overweight: '61 - 66 g',
      },
      {
        weight: '5 - 6 months',
        idealWeight: '2.3 - 2.9 kg',
        overweight: '69 - 67 g',
      },
      {
        weight: '7 - 12 months',
        idealWeight: '3.1 - 4 kg',
        overweight: '64 - 51 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Kitten_Sterilised_2kg.jpg',
    id: 'RC_Kitten_Sterilised_2kg',
    name: 'Royal Canin Kitten Sterilised (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 323,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'Sterilised',
    sterilised: 'Yes',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Sterilised Kitten Food is specially for neutered kittens (from 6 to 12 months old).With nutrients included to help support your kitten’s natural defenses after being spayed or neutered, you can help maintain its health throughout its...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Sterilised Kitten Food</strong> is s<span>pecially for neutered kittens (from 6 to 12 months old).</span></p><p>With nutrients included to help support your kitten’s natural defenses after being spayed or neutered, you can help maintain its health throughout its second age life stage.</p><p><strong>Key Features:</strong></p><ul><li><strong>Growth &amp; Weight Control - </strong>After neutering energy needs change and the risk of becoming overweight increases. This diet is formulated with a moderate level of fat to limit any potential weight gain. </li><li><strong>Immune System Support - </strong>Premium formula designed to support your kitten’s natural defences during this essential growth stage.</li><li><strong>Urinary Health - </strong>Contains a combination of minerals that help maintain your adult cat\\\\\\\'s urinary system.</li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li></ul></div>',
    keyBenefits: [
      'Growth & Weight Control -',
      'Immune System Support -',
      'Urinary Health -',
      'Digestive Health -',
    ],
    feedingGuide: [
      {
        weight: 'KITTEN\'S AGE',
        idealWeight: '6 - 9 MONTHS',
        overweight: '10 - 12 MONTHS',
      },
      {
        weight: 'Kitten\'s weight',
        idealWeight: '2,4 - 4,5 kg',
        overweight: '2,9 - 5 kg',
      },
      {
        weight: 'Kibbles only',
        idealWeight: '70 - 100 g',
        overweight: '68 - 100 g',
      },
      {
        weight: 'Kibble + pouch "Royal Canin Kitten Sterilised"',
        idealWeight: '45 - 70 g + 1 pouch',
        overweight: '40 - 70 g + 1 pouch',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Digestive Care, Urinary Care, Weight Control',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  // -- Mother & Babycat --
  {
    image: '/pet_images/RC_Mother_Babycat_2kg.jpg',
    id: 'RC_Mother_Babycat_2kg',
    name: 'Royal Canin Mother & Babycat (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 376,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Instinctive Babycat Canned Food is designed for kittens from 1 to 4 months. It is a unique ultra-soft mousse for weaning kittens under 4 months of age and is also ideal for gestating and lactating queens.It features the optimal...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Instinctive Babycat Canned Food</strong> is designed for kittens from 1 to 4 months. It is a unique ultra-soft mousse for weaning kittens under 4 months of age and is also ideal for gestating and lactating queens.</p><p>It features the optimal balance of proteins, fats and carbohydrates at this stage of a kitten\\\'s development. This helps to ensure a kitten enjoys its meal, and benefits from all of the nutrients included in the formula.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Age Easy Start - </strong>The "mousse" texture facilitates the easy transition to solid food.</li><li><strong>Instinctively Preferred - </strong>Prefferred by kittens and gestating queens due to its natritional profile.</li><li><strong>Immune System Support - </strong>Helps to support kittens\\\' natural defences.</li></ul></div>',
    keyBenefits: [
      'Age Easy Start -',
      'Instinctively Preferred -',
      'Immune System Support -',
    ],
    feedingGuide: [
      {
        weight: 'AGE (WEEKS)',
        idealWeight: 'CANS ONLY PER DAY',
        overweight: '1/2 CAN + DRY FOOD',
      },
      {
        weight: '4 weeks',
        idealWeight: 'Introduce food gradually',
        overweight: 'N/A',
      },
      {
        weight: '8 weeks',
        idealWeight: '3/4-1 cans',
        overweight: '1/2 can + 15-30 g dry food',
      },
      {
        weight: '12 weeks',
        idealWeight: '1-1 1/2 cans',
        overweight: '1/2 can + 25-45 g dry food',
      },
      {
        weight: '16 + weeks',
        idealWeight: '1 1/4-1 1/2 cans or transition to Royal Canin Kitten',
        overweight: '1/2 can + 30+50 g or transition to Royal Canin Kitten',
      },
      {
        weight: 'Adult lactating mother',
        idealWeight: 'Ad libitum',
        overweight: 'Ad libitum',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Can',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mother_Babycat_4kg.jpg',
    id: 'RC_Mother_Babycat_4kg',
    name: 'Royal Canin Mother & Babycat (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 666,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Instinctive Babycat Canned Food is designed for kittens from 1 to 4 months. It is a unique ultra-soft mousse for weaning kittens under 4 months of age and is also ideal for gestating and lactating queens.It features the optimal...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Instinctive Babycat Canned Food</strong> is designed for kittens from 1 to 4 months. It is a unique ultra-soft mousse for weaning kittens under 4 months of age and is also ideal for gestating and lactating queens.</p><p>It features the optimal balance of proteins, fats and carbohydrates at this stage of a kitten\\\'s development. This helps to ensure a kitten enjoys its meal, and benefits from all of the nutrients included in the formula.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Age Easy Start - </strong>The "mousse" texture facilitates the easy transition to solid food.</li><li><strong>Instinctively Preferred - </strong>Prefferred by kittens and gestating queens due to its natritional profile.</li><li><strong>Immune System Support - </strong>Helps to support kittens\\\' natural defences.</li></ul></div>',
    keyBenefits: [
      'Age Easy Start -',
      'Instinctively Preferred -',
      'Immune System Support -',
    ],
    feedingGuide: [
      {
        weight: 'AGE (WEEKS)',
        idealWeight: 'CANS ONLY PER DAY',
        overweight: '1/2 CAN + DRY FOOD',
      },
      {
        weight: '4 weeks',
        idealWeight: 'Introduce food gradually',
        overweight: 'N/A',
      },
      {
        weight: '8 weeks',
        idealWeight: '3/4-1 cans',
        overweight: '1/2 can + 15-30 g dry food',
      },
      {
        weight: '12 weeks',
        idealWeight: '1-1 1/2 cans',
        overweight: '1/2 can + 25-45 g dry food',
      },
      {
        weight: '16 + weeks',
        idealWeight: '1 1/4-1 1/2 cans or transition to Royal Canin Kitten',
        overweight: '1/2 can + 30+50 g or transition to Royal Canin Kitten',
      },
      {
        weight: 'Adult lactating mother',
        idealWeight: 'Ad libitum',
        overweight: 'Ad libitum',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Can',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  // -- Adult Dry Food --
  {
    image: '/pet_images/RC_Fit_Active_2kg.jpg',
    id: 'RC_Fit_Active_2kg',
    name: 'Royal Canin Fit (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 387,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Health Fit Cat Food is designed for active, adult cats with outdoor access, over 1 years old.Donut shaped kibble encourages chewing to help slow ingestion and has an adapted calorie content to help maintain the ideal weight of...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Fit Cat Food</strong> is designed for active, adult cats with outdoor access, over 1 years old.</p><p>Donut shaped kibble encourages chewing to help slow ingestion and has an adapted calorie content to help maintain the ideal weight of cats.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Optimal Nutrient Profile - </strong>Contains beneficial nutrition that is formulated to maintain good health in your adult cat.</li><li><strong>Healthy Weight - </strong>Adapted calorie content maintains an ideal weight of moderately active adult cats.</li><li><strong>Hairball Reduction - </strong>Specific fibre helps to stimulate intestinal transit and eliminate ingested hair. </li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Optimal Nutrient Profile -',
      'Healthy Weight -',
      'Hairball Reduction -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'IDEAL WEIGHT',
        overweight: 'OVERWEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '44 g (26g + 1 pouch)',
        overweight: '35 g (17 g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '54 g (36 g + 1 pouch)',
        overweight: '43 g (25 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '63 g (45 g + 1 pouch)',
        overweight: '51 g (39g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '72 g (54 g + 1 pouch)',
        overweight: '58 g (39g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Fit_Active_4kg.jpg',
    id: 'RC_Fit_Active_4kg',
    name: 'Royal Canin Fit (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 667,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Health Fit Cat Food is designed for active, adult cats with outdoor access, over 1 years old.Donut shaped kibble encourages chewing to help slow ingestion and has an adapted calorie content to help maintain the ideal weight of...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Fit Cat Food</strong> is designed for active, adult cats with outdoor access, over 1 years old.</p><p>Donut shaped kibble encourages chewing to help slow ingestion and has an adapted calorie content to help maintain the ideal weight of cats.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Optimal Nutrient Profile - </strong>Contains beneficial nutrition that is formulated to maintain good health in your adult cat.</li><li><strong>Healthy Weight - </strong>Adapted calorie content maintains an ideal weight of moderately active adult cats.</li><li><strong>Hairball Reduction - </strong>Specific fibre helps to stimulate intestinal transit and eliminate ingested hair. </li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Optimal Nutrient Profile -',
      'Healthy Weight -',
      'Hairball Reduction -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'IDEAL WEIGHT',
        overweight: 'OVERWEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '44 g (26g + 1 pouch)',
        overweight: '35 g (17 g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '54 g (36 g + 1 pouch)',
        overweight: '43 g (25 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '63 g (45 g + 1 pouch)',
        overweight: '51 g (39g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '72 g (54 g + 1 pouch)',
        overweight: '58 g (39g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Indoor_2kg.jpg',
    id: 'RC_Indoor_2kg',
    name: 'Royal Canin Indoor (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 412,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Indoor',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Health Indoor Cat Food is a specially formulated dry cat food for adult cats who have an indoor lifestyle, from 1 to 7 years old. Indoor adult cats tend to get less exercise than outdoor cats, that\'s why a balanced and complete diet...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Indoor Cat Food</strong> is a specially formulated dry cat food for adult cats who have an indoor lifestyle, from 1 to 7 years old. </p><p><span>Indoor adult cats tend to get less exercise than outdoor cats, that\\\'s why a balanced and complete diet containing beneficial nutrients is important for optimal health.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Stool &amp; Odour Reduction - </strong>A lack of exercise may lead to a slower intestinal transit which can result in smelly stools. This nutrition helps to reduce stool odor with highly digestible proteins and precise fiber content.</li><li><strong>Moderate Calorie - </strong>Helps to maintain a healthy weight, due to a moderate fat content. </li><li><strong>Hairball Reduction - </strong>Specific fibres help to stimulate intestinal transit and eliminate ingested hair.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Stool & Odour Reduction -',
      'Moderate Calorie -',
      'Hairball Reduction -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'IDEAL WEIGHT',
        overweight: 'OVERWEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '45 g (26 g + 1 pouch)',
        overweight: '36 g (17g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '56 g (36 g + 1 pouch)',
        overweight: '44 g (25 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '65 g (46 g + 1 pouch)',
        overweight: '52 g (32 g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '74 g (55 g + 1 pouch)',
        overweight: '59 g (40 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Joint Care, Skin & Coat, Urinary Care',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Indoor_4kg.jpg',
    id: 'RC_Indoor_4kg',
    name: 'Royal Canin Indoor (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 706,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Indoor',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Health Indoor Cat Food is a specially formulated dry cat food for adult cats who have an indoor lifestyle, from 1 to 7 years old. Indoor adult cats tend to get less exercise than outdoor cats, that\'s why a balanced and complete diet...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Indoor Cat Food</strong> is a specially formulated dry cat food for adult cats who have an indoor lifestyle, from 1 to 7 years old. </p><p><span>Indoor adult cats tend to get less exercise than outdoor cats, that\\\'s why a balanced and complete diet containing beneficial nutrients is important for optimal health.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Stool &amp; Odour Reduction - </strong>A lack of exercise may lead to a slower intestinal transit which can result in smelly stools. This nutrition helps to reduce stool odor with highly digestible proteins and precise fiber content.</li><li><strong>Moderate Calorie - </strong>Helps to maintain a healthy weight, due to a moderate fat content. </li><li><strong>Hairball Reduction - </strong>Specific fibres help to stimulate intestinal transit and eliminate ingested hair.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Stool & Odour Reduction -',
      'Moderate Calorie -',
      'Hairball Reduction -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'IDEAL WEIGHT',
        overweight: 'OVERWEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '45 g (26 g + 1 pouch)',
        overweight: '36 g (17g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '56 g (36 g + 1 pouch)',
        overweight: '44 g (25 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '65 g (46 g + 1 pouch)',
        overweight: '52 g (32 g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '74 g (55 g + 1 pouch)',
        overweight: '59 g (40 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Joint Care, Skin & Coat, Urinary Care',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sterilised_2kg.jpg',
    id: 'RC_Sterilised_2kg',
    name: 'Royal Canin Sterilised (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 412,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Sterilised',
    sterilised: 'Yes',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Sterilised Cat Food is specially for neutered cats (from 1 to 7 years old).Royal Canin Sterilised 37 food also contains a carefully considered balance of minerals that help to support and maintain a healthy urinary system for your...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Sterilised Cat Food</strong> is s<span>pecially for neutered cats (from 1 to 7 years old).</span></p><p><span>Royal Canin Sterilised 37 food also contains a carefully considered balance of minerals that help to support and maintain a healthy urinary system for your cat, while the increased protein content in this food helps to maintain your cat\\\'s healthy muscle mass.</span></p><p><strong>Key Features:</strong></p><ul><li><strong>Weight Management - </strong>Limits the risk of excess weight gain after neutering through a moderate level of fat and adequate daily rations.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li><li><strong>High Protein Content -</strong> Maintains muscle mass thanks to a high protein content. </li><li><strong>L-carnitine - </strong>Nutrition formulated to support fat metabolism.</li></ul></div>',
    keyBenefits: [
      'Weight Management -',
      'Urinary Health -',
      'High Protein Content -',
      'L-carnitine -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\' WEIGHT',
        idealWeight: '3 KG',
        overweight: '4 KG',
      },
      {
        weight: 'Ideal weight (Kibbles only)',
        idealWeight: '47 g',
        overweight: '57 g',
      },
      {
        weight: '"Ideal weight (Kibbles + 1 pouch ""Royal Canin Sterilised"")"',
        idealWeight: '30 g + 1 pouch',
        overweight: '41 g + 1 pouch',
      },
      {
        weight: 'Overweight (Kibbles only)',
        idealWeight: '37 g',
        overweight: '46 g',
      },
      {
        weight: 'Overweight (Kibbles + 1 pouch)',
        idealWeight: '21 g + 1 pouch',
        overweight: '29 g + 1 pouch',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Hairball_Care_2kg.jpg',
    id: 'RC_Hairball_Care_2kg',
    name: 'Royal Canin Hairball Care (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 446,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Hairball care',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Hairball Care Cat Food is designed for indoor cats prone to hairballs from 1 years old and older.The lifestyle of the indoor cat, sheltered from temperature variations and changes in day length, disrupts the natural seasonal cycle of...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Hairball Care Cat Food</strong> is designed for indoor cats prone to hairballs from 1 years old and older.</p><p>The lifestyle of the indoor cat, sheltered from temperature variations and changes in day length, disrupts the natural seasonal cycle of fur growth, so that it sheds almost continuously, aggravating the problem of hair swallowed during grooming.</p><p><strong>Key Benefits:</strong></p><ul><li><span><strong>Hairball Care : </strong><span>The exclusive Hairball Care complex is composed of a specific blend of dietary fibres, including psyllium (rich in mucilage), and insoluble fibres to help naturally stimulate intestinal transit. As a consequence, hair swallowed daily can be eliminated in the faeces rather than building up in the stomach and being regurgitated.</span></span></li><li><strong>Proven results in 14 days dietary fibre blend psyllium : </strong>Proven results: the exclusive use of Hairball Care is effective after 14 days.</li><li><strong>Urinary health : </strong><span>Formulated with a balance of minerals to help maintain the health of an adult cat’s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Hairball Care :',
      'Proven results in 14 days dietary fibre blend  psyllium :',
      'Urinary health :',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: '3 KG',
        overweight: '4 KG',
      },
      {
        weight: 'Ideal weight',
        idealWeight: '45 g',
        overweight: '55 g',
      },
      {
        weight: 'Overweight',
        idealWeight: '36 g',
        overweight: '44 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Digestive Care, Hairball Control',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Hairball_Care_4kg.jpg',
    id: 'RC_Hairball_Care_4kg',
    name: 'Royal Canin Hairball Care (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 782,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Hairball care',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Hairball Care Cat Food is designed for indoor cats prone to hairballs from 1 years old and older.The lifestyle of the indoor cat, sheltered from temperature variations and changes in day length, disrupts the natural seasonal cycle of...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Hairball Care Cat Food</strong> is designed for indoor cats prone to hairballs from 1 years old and older.</p><p>The lifestyle of the indoor cat, sheltered from temperature variations and changes in day length, disrupts the natural seasonal cycle of fur growth, so that it sheds almost continuously, aggravating the problem of hair swallowed during grooming.</p><p><strong>Key Benefits:</strong></p><ul><li><span><strong>Hairball Care : </strong><span>The exclusive Hairball Care complex is composed of a specific blend of dietary fibres, including psyllium (rich in mucilage), and insoluble fibres to help naturally stimulate intestinal transit. As a consequence, hair swallowed daily can be eliminated in the faeces rather than building up in the stomach and being regurgitated.</span></span></li><li><strong>Proven results in 14 days dietary fibre blend psyllium : </strong>Proven results: the exclusive use of Hairball Care is effective after 14 days.</li><li><strong>Urinary health : </strong><span>Formulated with a balance of minerals to help maintain the health of an adult cat’s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Hairball Care :',
      'Proven results in 14 days dietary fibre blend  psyllium :',
      'Urinary health :',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: '3 KG',
        overweight: '4 KG',
      },
      {
        weight: 'Ideal weight',
        idealWeight: '45 g',
        overweight: '55 g',
      },
      {
        weight: 'Overweight',
        idealWeight: '36 g',
        overweight: '44 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Digestive Care, Hairball Control',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sensitive_Skin_2kg.jpg',
    id: 'RC_Sensitive_Skin_2kg',
    name: 'Royal Canin Hair & Skin Care (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 446,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Sensitive skin',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Feline Hair & Skin Care Cat Food is a balanced and complete feed for adult cats, recommended to support healthy skin and coat. It is an exclusive complex of nutrients that help to support the skin\'s barrier role. It contains high quality...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Feline Hair &amp; Skin Care Cat Food</strong> is a balanced and complete feed for adult cats, recommended to support healthy skin and coat.</p><p><span>It is an exclusive complex of nutrients that help to support the skin\\\\\\\'s barrier role. It contains high quality proteins, including specific amino acids, to maintain healthy hair growth and skin renewal.</span></p><p><strong>Benefits:</strong></p><ul><li>Includes B Vitamins: helps support the skin\\\\\\\'s role as a protective barrier</li><li>High quality proteins: very high digestibility for digestive health and stool quality</li><li>Omega 3 and Omega 6 fatty acids: beneficial effects on skin health and coat condition.</li></ul></div>',
    keyBenefits: [
      'Includes B Vitamins: helps support the skin\'s role as a protective barrier',
      'High quality proteins: very high digestibility for digestive health and stool quality',
      'Omega 3 and Omega 6 fatty acids: beneficial effects on skin health and coat condition.',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'IDEAL WEIGHT (G/DAY)',
        overweight: 'OVERWEIGHT (G/DAY)',
      },
      {
        weight: '3 kg',
        idealWeight: '45 g',
        overweight: '36 g',
      },
      {
        weight: '4 kg',
        idealWeight: '55 g',
        overweight: '44 g',
      },
      {
        weight: '5 kg',
        idealWeight: '65 g',
        overweight: '52 g',
      },
      {
        weight: '6 kg',
        idealWeight: '74 g',
        overweight: '59 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food, Skin & Coat',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Digestive_Care_2kg.png',
    id: 'RC_Digestive_Care_2kg',
    name: 'Royal Canin Digestive Care (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 446,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Digestive care',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Feline Care Nutrition Digestive Care Cat Food is a balanced dry food for cats with sensitive digestive systems. It is formulated for cats 1 year and older with sensitive stomachs. Key Features: Highly Digestible Proteins (L.I.P): 90–95%...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Feline Care Nutrition Digestive Care Cat Food </strong> is a balanced dry food for cats with sensitive digestive systems. It is formulated for cats 1 year and older with sensitive stomachs.</p><p><strong>Key Features: </strong></p><ul><li>Highly Digestible Proteins (L.I.P): 90–95% digestibility rate</li><li>Prebiotics &amp; Psyllium for Gut Health</li><li>Ring-shaped kibble: promotes chewing and slows down eating, aiding in digestion and reducing regurgitation risk.</li></ul></div>',
    keyBenefits: [
      'Highly Digestible Proteins (L.I.P): 90–95% digestibility rate',
      'Prebiotics & Psyllium for Gut Health',
      'Ring-shaped kibble: promotes chewing and slows down eating, aiding in digestion and reducing regurgitation risk.',
    ],
    feedingGuide: [
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
    ],
    additionalInfo: {
      barcode: '3182550751995',
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Digestive Care',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'No',
      lifestage: 'All',
      size: 'No',
      size_chart: 'No',
    },
  },
  // -- Outdoor & Savour Exigent --
  {
    image: '/pet_images/RC_Outdoor_2kg.jpg',
    id: 'RC_Outdoor_2kg',
    name: 'Royal Canin Outdoor (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 412,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Health Outdoor Cat Food is a specially formulated dry cat food for adult cats who enjoy an active outdoor lifestyle, from 1 to 7 years old.Your active cat needs nutrition that is specifically designed to support their high energy...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Outdoor Cat Food</strong> is a specially formulated dry cat food for adult cats who enjoy an active outdoor lifestyle, from 1 to 7 years old.</p><p>Your active cat needs nutrition that is specifically designed to support their high energy levels and curious lifestyle.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Activity Support - </strong>Formulated to support the higher energy needs of outdoor cats with nutrition that has higher calorie content.</li><li><strong>Healthy Coat -</strong> Contains nutrients that help to support the skin\\\'s "barrier role" and maintain skin &amp; coat health. </li><li><strong><span>Joint &amp; Bone Support - </span></strong><span>H</span><span>elps to develop healthy bones and joints through fatty acids (EPA &amp; DHA) and selected nutrients. </span></li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Activity Support -',
      'Healthy Coat -',
      'Joint & Bone Support -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'IDEAL WEIGHT',
        overweight: 'OVERWEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '40 g (23 g + 1 pouch)',
        overweight: '32 g (15 g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '49 g (32 g + 1 pouch)',
        overweight: '39 g (22 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '58 g (41 g + 1 pouch)',
        overweight: '46 g (29 g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '66 g (49g + 1 pouch)',
        overweight: '53 g (35 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Joint Care, Skin & Coat',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Outdoor_4kg.jpg',
    id: 'RC_Outdoor_4kg',
    name: 'Royal Canin Outdoor (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 706,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Health Outdoor Cat Food is a specially formulated dry cat food for adult cats who enjoy an active outdoor lifestyle, from 1 to 7 years old.Your active cat needs nutrition that is specifically designed to support their high energy...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Outdoor Cat Food</strong> is a specially formulated dry cat food for adult cats who enjoy an active outdoor lifestyle, from 1 to 7 years old.</p><p>Your active cat needs nutrition that is specifically designed to support their high energy levels and curious lifestyle.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Activity Support - </strong>Formulated to support the higher energy needs of outdoor cats with nutrition that has higher calorie content.</li><li><strong>Healthy Coat -</strong> Contains nutrients that help to support the skin\\\'s "barrier role" and maintain skin &amp; coat health. </li><li><strong><span>Joint &amp; Bone Support - </span></strong><span>H</span><span>elps to develop healthy bones and joints through fatty acids (EPA &amp; DHA) and selected nutrients. </span></li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Activity Support -',
      'Healthy Coat -',
      'Joint & Bone Support -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'IDEAL WEIGHT',
        overweight: 'OVERWEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '40 g (23 g + 1 pouch)',
        overweight: '32 g (15 g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '49 g (32 g + 1 pouch)',
        overweight: '39 g (22 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '58 g (41 g + 1 pouch)',
        overweight: '46 g (29 g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '66 g (49g + 1 pouch)',
        overweight: '53 g (35 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Joint Care, Skin & Coat',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Savour_Exigent_2kg.jpg',
    id: 'RC_Savour_Exigent_2kg',
    name: 'Royal Canin Fussy (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 412,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Health Exigent Cat Food is designed for adult cats who are sensitive to food texture, over 1 years old.Formulated for fussy eaters, Exigent is made with two differently shaped, textured and formulated kibbles to increase the appeal...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Exigent Cat Food</strong> is designed for adult cats who are sensitive to food texture, over 1 years old.</p><p>Formulated for fussy eaters, <strong>Exigent</strong> is made with two differently shaped, textured and formulated kibbles to increase the appeal of the food while it is in the cats mouth.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Dual Savour Sensation - </strong>Stimulates the natural preference of fussy eaters through two synergistic kibbles of different shape, composition and texture.</li><li><strong>Optimal Weight - </strong>Maintains an ideal weight for fussy cats through adapted energy content.</li><li><strong>Individual Preference - </strong>Royal Canin has developed three different formulas to satisfy even the fussiest cats.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Dual Savour Sensation -',
      'Optimal Weight -',
      'Individual Preference -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'UNDER WEIGHT',
        overweight: 'IDEAL WEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '51 g',
        overweight: '43 g',
      },
      {
        weight: '4 kg',
        idealWeight: '63 g',
        overweight: '53 g',
      },
      {
        weight: '5 kg',
        idealWeight: '74 g',
        overweight: '62 g',
      },
      {
        weight: '6 kg',
        idealWeight: '-',
        overweight: '70 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Weight Control',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  // -- Breed-specific Dry Food --
  {
    image: '/pet_images/RC_Maine_Coon_Adult_2kg.jpg',
    id: 'RC_Maine_Coon_Adult_2kg',
    name: 'Royal Canin Maine Coon Adult (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 446,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Maine Coon',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Maine Coon Cat Food is designed exclusively for Pure Breed Maine Coon cats over 15 months. These gentle giants need nutrition that is specifically designed to support their bigger bodies and high energy levels.Key Benefits:Exclusive...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Maine Coon Cat Food</strong> is designed exclusively for Pure Breed Maine Coon cats over 15 months. </p><p>These gentle giants need nutrition that is specifically designed to support their bigger bodies and high energy levels.</p><p><strong>Key Benefits:</strong></p><ul><li><strong><strong><span>Exclusive Kibble Design - </span></strong></strong>Tailor-made kibble is adapted to the large square jaw of the Maine Coon. The unique kibble encourages chewing to help support oral hygiene.</li><li><strong>Joint Support - </strong>Enriched with EPA &amp; DHA to support healthy bones and joints. </li><li><strong><span>Cardiac Health - </span></strong><span>Specifically formulated balance of minerals in this food helps to support and maintain your cat\\\\\\\'s healthy cardiac function.</span></li><li><strong>Coat &amp; Skin Health -</strong> Contains nutrients that help to provide the nourishment needed to maintain the good health of your Maine Coon’s skin and silky coat.</li><li><strong>Urinary Health - </strong>Contains a combination of minerals that help maintain your adult cat\\\\\\\'s urinary system.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design -',
      'Joint Support -',
      'Cardiac Health -',
      'Coat & Skin Health -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'LOW ENERGY NEEDS',
        overweight: 'MODERATE / ACTIVE ENERGY NEEDS',
      },
      {
        weight: '4 to 5 kg',
        idealWeight: '41 - 48 g (20 - 27 g + 1 pouch)',
        overweight: '52 - 60 g (30 - 39 g + 1 pouch)',
      },
      {
        weight: '6 to 7 kg',
        idealWeight: '55 - 61 g (34 - 40 g + 1 pouch)',
        overweight: '69 - 77 g (47 - 55 g + 1 pouch)',
      },
      {
        weight: '8 to 9 kg',
        idealWeight: '67 - 73 g (46 - 52 g + 1 pouch)',
        overweight: '84 - 92 g (63 - 70g + 1 pouch)',
      },
      {
        weight: '10 kg',
        idealWeight: '79 g (58 g + 1 pouch)',
        overweight: '99g (78 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Maine Coon',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Maine_Coon_Adult_4kg.jpg',
    id: 'RC_Maine_Coon_Adult_4kg',
    name: 'Royal Canin Maine Coon Adult (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 786,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Maine Coon',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Maine Coon Cat Food is designed exclusively for Pure Breed Maine Coon cats over 15 months. These gentle giants need nutrition that is specifically designed to support their bigger bodies and high energy levels.Key Benefits:Exclusive...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Maine Coon Cat Food</strong> is designed exclusively for Pure Breed Maine Coon cats over 15 months. </p><p>These gentle giants need nutrition that is specifically designed to support their bigger bodies and high energy levels.</p><p><strong>Key Benefits:</strong></p><ul><li><strong><strong><span>Exclusive Kibble Design - </span></strong></strong>Tailor-made kibble is adapted to the large square jaw of the Maine Coon. The unique kibble encourages chewing to help support oral hygiene.</li><li><strong>Joint Support - </strong>Enriched with EPA &amp; DHA to support healthy bones and joints. </li><li><strong><span>Cardiac Health - </span></strong><span>Specifically formulated balance of minerals in this food helps to support and maintain your cat\\\\\\\'s healthy cardiac function.</span></li><li><strong>Coat &amp; Skin Health -</strong> Contains nutrients that help to provide the nourishment needed to maintain the good health of your Maine Coon’s skin and silky coat.</li><li><strong>Urinary Health - </strong>Contains a combination of minerals that help maintain your adult cat\\\\\\\'s urinary system.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design -',
      'Joint Support -',
      'Cardiac Health -',
      'Coat & Skin Health -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'LOW ENERGY NEEDS',
        overweight: 'MODERATE / ACTIVE ENERGY NEEDS',
      },
      {
        weight: '4 to 5 kg',
        idealWeight: '41 - 48 g (20 - 27 g + 1 pouch)',
        overweight: '52 - 60 g (30 - 39 g + 1 pouch)',
      },
      {
        weight: '6 to 7 kg',
        idealWeight: '55 - 61 g (34 - 40 g + 1 pouch)',
        overweight: '69 - 77 g (47 - 55 g + 1 pouch)',
      },
      {
        weight: '8 to 9 kg',
        idealWeight: '67 - 73 g (46 - 52 g + 1 pouch)',
        overweight: '84 - 92 g (63 - 70g + 1 pouch)',
      },
      {
        weight: '10 kg',
        idealWeight: '79 g (58 g + 1 pouch)',
        overweight: '99g (78 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Maine Coon',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Persian_Adult_2kg.jpg',
    id: 'RC_Persian_Adult_2kg',
    name: 'Royal Canin Persian Adult (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 446,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Persian',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Persian Cat Food is designed exclusively for Pure Breed Persian cats over 12 months.This dignified breed is known for being quiet and sweet. Despite their docile nature, they need nutrition that is specifically designed to support...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Persian Cat Food</strong> is designed exclusively for Pure Breed Persian cats over 12 months.</p><p>This <span>dignified breed</span><span> is known for being quiet and sweet. Despite their docile nature, they need nutrition that is specifically designed to support their playful and curious lifestyle.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong><strong><span>Exclusive Kibble Design - </span></strong></strong>Exclusive almond-shaped kibble is designed with an optimal contact surface area is easy for the Persian cat to pick up and chew.</li><li><strong>Healthy Coat -</strong> Contains nutrients that help to support the skin\\\'s "barrier role" and maintain skin health &amp; coat beauty (EPA &amp; DHA). </li><li><strong>Hairball Reduction -</strong> A specific blend of fibres helps to naturally stimulate intestinal transit, eliminate ingested hair and control hairball formation.</li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design -',
      'Healthy Coat -',
      'Hairball Reduction -',
      'Digestive Health -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'LOW ENERGY NEEDS',
        overweight: 'MODERATE / ACTIVE ENERGY NEEDS',
      },
      {
        weight: '3 kg',
        idealWeight: '33 g (11 g + 1 pouch)',
        overweight: '41 g (19 g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '40 g (18 g + 1 pouch)',
        overweight: '50 g (29 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '47 g (25 g + 1 pouch)',
        overweight: '59 g (37 g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '54 g (32 g + 1 pouch)',
        overweight: '67 g (45 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Persian',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Siamese_Adult_2kg.png',
    id: 'RC_Siamese_Adult_2kg',
    name: 'Royal Canin Siamese Adult (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 446,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Siamese',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Siamese Cat Food is designed exclusively for pure breed Siamese cats over 12 months.Royal Canin Siamese Adult food has an increased level of protein and a moderate fat level to help preserve your cat\'s long, slender and muscular body...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Siamese Cat Food</strong> is designed exclusively for pure breed Siamese cats over 12 months.</p><p><span>Royal Canin Siamese Adult food has an increased level of protein and a moderate fat level to help preserve your cat\\\'s long, slender and muscular body type.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Exclusive Kibble Design - </strong>Exclusive tailor-made kibble is adapted to your Siamese\\\'s narrow and long muzzle. Designed to encourage chewing to help reduce the rate of food intake.</li><li><strong>Exclusive Formula - </strong>Enriched with 6 fatty acids and L-carnitine, both involved in healthy fat metabolism.</li><li><strong>Muscle Tone - </strong>Siamese cats typically have an elegant and athletic silhouette. The precise protein content and moderate fat levels helps to maintain their muscular body. </li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora. </li><li><strong>Healthy glossy coat - </strong>Combination of specific nutrients help to maintain healthy skin and shiny coat.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design -',
      'Exclusive Formula -',
      'Muscle Tone -',
      'Digestive Health -',
      'Healthy glossy coat -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'LOW ENERGY NEEDS',
        overweight: 'MODERATE / ACTIVE ENERGY NEEDS',
      },
      {
        weight: '3 kg',
        idealWeight: '33 g (12 g + 1 pouch)',
        overweight: '42 g (21 g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '41 g (20 g + 1 pouch)',
        overweight: '51 g (30 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '48 g (27 g + 1 pouch)',
        overweight: '60 g (39 g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '55 g (34 g + 1 pouch)',
        overweight: '68 g (47 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Siamese',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sphynx_Adult_2kg.jpg',
    id: 'RC_Sphynx_Adult_2kg',
    name: 'Royal Canin Sphynx Adult (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 446,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Sphynx',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Sphynx Cat Food is designed exclusively for Pure Breed Sphynx cats over 12 months old. This highly intelligent, playful and cuddly breed deserved the best nutrition to help support their high energy levels and curious lifestyle!Key...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Sphynx Cat Food</strong> is designed exclusively for Pure Breed Sphynx cats over 12 months old. </p><p>This highly intelligent, playful and cuddly breed deserved the best nutrition to help support their high energy levels and curious lifestyle!</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Exclusive Kibble Design - </strong>Exclusive tailor-made kibble is adapted to the Sphynx\\\\\\\'s jaw. Designed to help them easily pick up and chew their food.</li><li><strong>Dental Health - </strong>Reduce tartar formation thanks to calcium chelators.</li><li><strong>High Energy Intake - </strong>To compensate for the absence of hair, the Sphynx has a very active metabolism to control body temperature. To meet the high energy levels of the Sphynx, this formula has a high level of fat. </li><li><strong>Skin Health -</strong> Contains nutrients that help to support the skin\\\\\\\'s "barrier role" and maintain skin health.</li><li><strong><span>Cardiac Health - </span></strong><span>Specifically formulated balance of minerals in this food helps to support and maintain your cat\\\\\\\'s healthy cardiac function.</span></li><li><strong>Urinary Health - </strong>Formulated with a balance of minerals to help maintain the health of an adult cat’s urinary system.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design -',
      'Dental Health -',
      'High Energy Intake -',
      'Skin Health -',
      'Cardiac Health -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: '3 KG',
        overweight: '4 KG',
      },
      {
        weight: 'Low energy needs (kibbles)',
        idealWeight: '49 g',
        overweight: '60 g',
      },
      {
        weight: 'Low energy needs (kibbles + pouch)',
        idealWeight: '28 g + 1 pouch',
        overweight: '39 g + 1 pouch',
      },
      {
        weight: 'Moderate energy needs (kibbles)',
        idealWeight: '56 g',
        overweight: '69 g',
      },
      {
        weight: 'Moderate energy needs (kibbles + pouch)',
        idealWeight: '36 g + 1 pouch',
        overweight: '49 g + 1 pouch',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dental Care, Dry Food, Skin & Coat',
      breed: 'Sphynx',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  // -- Breed-specific Kitten Dry Food --
  {
    image: '/pet_images/RC_Maine_Coon_Adult_2kg.jpg',
    id: 'RC_Maine_Coon_Kitten_2kg',
    name: 'Royal Canin Maine Coon Kitten (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 424,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: 'Maine Coon',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Maine Coon Kitten Food is designed exclusively for pure breed Maine Coon kittens up to 15 months old. Royal Canin Maine Coon Kitten contains a highly digestible protein known as Low Indigestible Protein, as well as prebiotics which...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Maine Coon Kitten Food</strong> is designed exclusively for pure breed Maine Coon kittens up to 15 months old. </p><p><span>Royal Canin Maine Coon Kitten contains a highly digestible protein known as Low Indigestible Protein, as well as prebiotics which help to support your kitten\\\\\\\'s intestinal flora.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Exclusive Kibble Design : </strong>The unique kibble encourages chewing to help support oral hygiene.</li><li><strong>Joint &amp; Bone Support : </strong>Contains minerals (including calcium and phosphorus) to help develop healthy bones and joints.</li><li><strong>Growth Support : </strong>Formulated with adapted energy and protein content to support your kitty during this essential growth stage. </li><li><strong>Digestive Health : </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Immune System Support : </strong>Premium formula designed to support your kitten’s natural defences during this essential growth stage.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design :',
      'Joint & Bone Support :',
      'Growth Support :',
      'Digestive Health :',
      'Immune System Support :',
    ],
    feedingGuide: [
      {
        weight: 'KITTEN\'S AGE',
        idealWeight: '3->4 MONTHS',
        overweight: '5->7 MONTHS',
      },
      {
        weight: 'Kitten\'s weight',
        idealWeight: '1.5-3.6 kg',
        overweight: '2.6-4.8 kg',
      },
      {
        weight: 'Dry food',
        idealWeight: '69-100 g',
        overweight: '77-109 g',
      },
      {
        weight: 'Mix food (wet + dry)',
        idealWeight: '1/2 can Mother & Babycat + 45-76 g',
        overweight: '1 pouch Kitten + 56-87 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Maine Coon',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Maine_Coon_Adult_4kg.jpg',
    id: 'RC_Maine_Coon_Kitten_4kg',
    name: 'Royal Canin Maine Coon Kitten (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 748,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: 'Maine Coon',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Maine Coon Kitten Food is designed exclusively for pure breed Maine Coon kittens up to 15 months old. Royal Canin Maine Coon Kitten contains a highly digestible protein known as Low Indigestible Protein, as well as prebiotics which...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Maine Coon Kitten Food</strong> is designed exclusively for pure breed Maine Coon kittens up to 15 months old. </p><p><span>Royal Canin Maine Coon Kitten contains a highly digestible protein known as Low Indigestible Protein, as well as prebiotics which help to support your kitten\\\\\\\'s intestinal flora.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Exclusive Kibble Design : </strong>The unique kibble encourages chewing to help support oral hygiene.</li><li><strong>Joint &amp; Bone Support : </strong>Contains minerals (including calcium and phosphorus) to help develop healthy bones and joints.</li><li><strong>Growth Support : </strong>Formulated with adapted energy and protein content to support your kitty during this essential growth stage. </li><li><strong>Digestive Health : </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Immune System Support : </strong>Premium formula designed to support your kitten’s natural defences during this essential growth stage.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design :',
      'Joint & Bone Support :',
      'Growth Support :',
      'Digestive Health :',
      'Immune System Support :',
    ],
    feedingGuide: [
      {
        weight: 'KITTEN\'S AGE',
        idealWeight: '3->4 MONTHS',
        overweight: '5->7 MONTHS',
      },
      {
        weight: 'Kitten\'s weight',
        idealWeight: '1.5-3.6 kg',
        overweight: '2.6-4.8 kg',
      },
      {
        weight: 'Dry food',
        idealWeight: '69-100 g',
        overweight: '77-109 g',
      },
      {
        weight: 'Mix food (wet + dry)',
        idealWeight: '1/2 can Mother & Babycat + 45-76 g',
        overweight: '1 pouch Kitten + 56-87 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Maine Coon',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  // -- Senior Dry Food --
  {
    image: '/pet_images/RC_Senior_2kg.jpg',
    id: 'RC_Senior_2kg',
    name: 'Royal Canin Ageing 11+ (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 421,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Health Ageing 12+ Cat Food is suitable for cats over 12 years of age and is specially formulated with the nutritional needs of senior cats like yours in mind. Royal Canin Senior Ageing 12+ helps to support healthy kidney function,...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>The Royal Canin Health Ageing 12+ Cat Food</strong> is suitable for cats over 12 years of age and is specially formulated with the nutritional needs of senior cats like yours in mind. Royal Canin Senior Ageing 12+ helps to support healthy kidney function, which is highly beneficial in senior cats.</p><p><strong>Key Features</strong></p><ul><li>Helps support renal healthy function thanks to a moderate phosphorus level.</li><li>Stimulate the senior cat’s appetite thanks to a highly palatable, double texture kibble which is easy to chew.</li><li>Contains specific nutrients to reduce consequences of ageing on cognitive function, mobility and oxidative stress</li><li>Contains a combination of minerals that help maintain your adult cat\\\\\\\'s urinary system.</li></ul></div>',
    keyBenefits: [
      'Helps support renal healthy function thanks to a moderate phosphorus level.',
      'Stimulate the senior cat’s appetite thanks to a highly palatable, double texture kibble which is easy to chew.',
      'Contains specific nutrients to reduce consequences of ageing on cognitive function, mobility and oxidative stress',
      'Contains a combination of minerals that help maintain your adult cat\'s urinary system.',
    ],
    feedingGuide: [
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Ageing',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Senior_4kg.jpg',
    id: 'RC_Senior_4kg',
    name: 'Royal Canin Ageing 11+ (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 714,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Health Ageing 12+ Cat Food is suitable for cats over 12 years of age and is specially formulated with the nutritional needs of senior cats like yours in mind. Royal Canin Senior Ageing 12+ helps to support healthy kidney function,...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>The Royal Canin Health Ageing 12+ Cat Food</strong> is suitable for cats over 12 years of age and is specially formulated with the nutritional needs of senior cats like yours in mind. Royal Canin Senior Ageing 12+ helps to support healthy kidney function, which is highly beneficial in senior cats.</p><p><strong>Key Features</strong></p><ul><li>Helps support renal healthy function thanks to a moderate phosphorus level.</li><li>Stimulate the senior cat’s appetite thanks to a highly palatable, double texture kibble which is easy to chew.</li><li>Contains specific nutrients to reduce consequences of ageing on cognitive function, mobility and oxidative stress</li><li>Contains a combination of minerals that help maintain your adult cat\\\\\\\'s urinary system.</li></ul></div>',
    keyBenefits: [
      'Helps support renal healthy function thanks to a moderate phosphorus level.',
      'Stimulate the senior cat’s appetite thanks to a highly palatable, double texture kibble which is easy to chew.',
      'Contains specific nutrients to reduce consequences of ageing on cognitive function, mobility and oxidative stress',
      'Contains a combination of minerals that help maintain your adult cat\'s urinary system.',
    ],
    feedingGuide: [
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Ageing',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sterilised_2kg.jpg',
    id: 'RC_Senior_Sterilised_2kg',
    name: 'Royal Canin Ageing Sterilised 12+ (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 421,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'Sterilised',
    sterilised: 'Yes',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Sterilised Ageing 12+ Cat Food is specially for neutered senior cats over 12 years old.Royal Canin Ageing Sterilised 12+ is specially formulated with the nutritional needs of your sterilised, senior cat in mind. Key Features :Weight...',
    longDescription:
      '<div class="std" itemprop="description"><p><span><strong>Royal Canin Sterilised Ageing 12+ Cat Food</strong> is s<span>pecially for neutered senior cats over 12 years old.</span></span></p><p><span><span><span>Royal Canin Ageing Sterilised 12+ is specially formulated with the nutritional needs of your sterilised, senior cat in mind. </span></span></span></p><p><strong>Key Features :</strong></p><ul><strong>Weight maintenance :</strong> In some senior cats, the level of activity reduces with age, which can lead to weight gain. Sterilised Ageing 12+ contains a moderate level of fat to help maintain an ideal body condition. The formula is enriched with L-carnitine.<li><strong>Healthy ageing complex :</strong> Limits the consequences of ageing on cognitive function, mobility, and oxidative stress thanks to specific nutrients.</li><li><strong>Renal health : </strong>A decline in kidney function is common in older cats. Ageing sterilised 12+ contains a moderate phosphorus level to help support renal health.</li><li><strong>Urinary health : </strong>Formulated to help maintain health of an adult cat’s urinary system.</li></ul></div>',
    keyBenefits: [
      'Healthy ageing complex :',
      'Renal health :',
      'Urinary health :',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: '3 KG',
        overweight: '4 KG',
      },
      {
        weight: 'Ideal weight',
        idealWeight: '44 g',
        overweight: '54 g',
      },
      {
        weight: 'Ideal weight (Mix food - Royal Canin Ageing 12+)',
        idealWeight: '24 g + 1 pouch',
        overweight: '34 g + 1 pouch',
      },
      {
        weight: 'Overweight',
        idealWeight: '35 g',
        overweight: '43 g',
      },
      {
        weight: 'Overweight (Mix food - Royal Canin Ageing 12+)',
        idealWeight: '16 g + 1 pouch',
        overweight: '24 g + pouch',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'None',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  // -- Wet Food --
  {
    image: '/pet_images/RC_Kitten_Wet_85g.jpg',
    id: 'RC_Kitten_Wet_85g',
    name: 'Royal Canin Kitten Instinctive in Gravy (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '100g',
    description:
      'The Royal Canin Wet Instinctive Kitten Food Pouch specially for 2nd age kittens up to 12 months old (thin slices in gravy).Royal Canin Kitten Instinctive in Gravy provides all the essential nutrients needed to sustain high energy requirements and...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Wet Instinctive Kitten Food Pouch</strong> s<span>pecially for 2nd age kittens up to 12 months old (thin slices in gravy).</span></p><p><span><span>Royal Canin Kitten Instinctive in Gravy provides all the essential nutrients needed to sustain high energy requirements and support bone strengthening as well as good overall health maintenance. </span></span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Premium formula designed to support your kitten’s natural defences during this essential growth stage.</li><li><strong>Instinctively Preferred - </strong>Preferred by kittens due to its nutritional profile.</li><li><strong>Easy Chewing- </strong>Small chunks of food in delicious gravy. </li></ul></div> To be stored in a cool, dry place.',
    keyBenefits: [
      'Immune System Support -',
      'Instinctively Preferred -',
      'Easy Chewing-',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Pouch',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Adult_Wet_85g.jpg',
    id: 'RC_Adult_Wet_85g',
    name: 'Royal Canin Instinctive in Gravy (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '100g',
    description:
      'The Royal Canin Wet Instinctive Chunks In Gravy Cat Food Pouch is a complete feed for adult cats (thin slices in gravy).With carefully selected nutrients included for optimal palatability, the end product is a dish that your cat simply won\'t be able...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Wet Instinctive Chunks In Gravy Cat Food Pouch</strong> is a c<span>omplete feed for adult cats (thin slices in gravy).</span></p><p><span>With carefully selected nutrients included for optimal palatability, the end product is a dish that your cat simply won\\\'t be able to resist. </span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Instinctively Preferred - </strong>Formulated to match the optimal macro nutritional profile instinctively preferred by adult cats.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li><li><strong>Maintains Ideal Weight -</strong><span>Maintains an ideal weight through adapted energy content.</span></li></ul></div>',
    keyBenefits: [
      'Instinctively Preferred -',
      'Urinary Health -',
      'Maintains Ideal Weight -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'WET POUCHES ONLY PER DAY',
        overweight: 'WET + DRY FOOD PER DAY',
      },
      {
        weight: '3 kg',
        idealWeight: '2.5',
        overweight: '1 pouch + 20-25 g dry food',
      },
      {
        weight: '4 kg',
        idealWeight: '3',
        overweight: '1 pouch + 35-40 g dry food',
      },
      {
        weight: '5 kg',
        idealWeight: '3.5',
        overweight: '1 pouch + 40-45 g dry food',
      },
      {
        weight: '6 kg',
        idealWeight: '4',
        overweight: '1 pouch + 45-55 g dry food',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Gravy, Pouch',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sterilised_2kg.jpg',
    id: 'RC_Sterilised_Wet_85g',
    name: 'Royal Canin Sterilised in Gravy (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Sterilised',
    sterilised: 'Yes',
    productSize: '100g',
    description:
      'The Royal Canin Wet Sterilised Cat Food Pouches is specially for neutered adult cats (thin slices in gravy).Royal Canin Sterilised in Gravy is formulated to match the optimal nutritional profile instinctively preferred by adult cats - to ensure that...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Wet Sterilised Cat Food Pouches</strong> is s<span>pecially for neutered adult cats (thin slices in gravy).</span></p><p><span>Royal Canin Sterilised in Gravy is formulated to match the optimal nutritional profile instinctively preferred by adult cats - to ensure that they consume the nutrients they need to maintain good overall health.</span></p><p><strong>Key Features:</strong></p><ul><li><strong>Weight maintenance - </strong> Helps maintain ideal weight of sterilised cats.</li><li><strong>Urinary Health - </strong>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</li><li><strong>Instinctively preferred - </strong>Formulated to match the optimal macro nutritional profile instinctively preferred by adult cats.</li></ul></div>',
    keyBenefits: [
      'Weight maintenance -',
      'Urinary Health -',
      'Instinctively preferred -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'IDEAL WEIGHT',
        overweight: 'IDEAL WEIGHT',
      },
      {
        weight: '',
        idealWeight: 'Pouches',
        overweight: '1 puch + dry',
      },
      {
        weight: '3kg',
        idealWeight: '3',
        overweight: '40-48 g',
      },
      {
        weight: '4kg',
        idealWeight: '3 + 1/2',
        overweight: '58-70 g',
      },
      {
        weight: '5kg',
        idealWeight: '4',
        overweight: '76-92 g',
      },
      {
        weight: '6kg',
        idealWeight: '4 + 1/2',
        overweight: '94-114 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Pouch, Weight Control',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Hairball_Care_4kg.jpg',
    id: 'RC_Hairball_Wet_85g',
    name: 'Royal Canin Hairball Care Chunks in Gravy (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Hairball care',
    sterilised: 'No',
    productSize: '100g',
    description:
      'Royal Canin Hairball Care Adult Wet Food Pouches controls hairball development with an exclusive blend of fibers that helps with digestive health. It also helps to maintain your cat\'s ideal weight - with a low fat content of just 2.7%. Serve alone...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Hairball Care Adult Wet Food Pouches</strong> controls hairball development with an exclusive blend of fibers that helps with digestive health. It also helps to maintain your cat\\\\\\\'s ideal weight - with a low fat content of just 2.7%. Serve alone or mix with your cat’s favorite dry Royal Canin adult cat food. <strong>Features:</strong></p><ul><li>Hairball control: Hairball Care is formulated to to help eliminate swallowed hair through transit stimulation</li><li>Maintains ideal weight: Helps maintain ideal weight</li><li>Healthy digestive system: High digestibility</li></ul></div>',
    keyBenefits: [
      'Hairball control: Hairball Care is formulated to to help eliminate swallowed hair through transit stimulation',
      'Maintains ideal weight: Helps maintain ideal weight',
      'Healthy digestive system: High digestibility',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Digestive Care, Pouch',
      breed: 'Non-Specific',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Digestive_Wet_85g.png',
    id: 'RC_Digestive_Wet_85g',
    name: 'Royal Canin Digestive Care Chunks in Gravy (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Digestive care',
    sterilised: 'No',
    productSize: '100g',
    description:
      'Royal Canin Wet Digest Sensitive Cat Food Pouch is formulated to support healthy digestion for your adult cat. This complete and balanced meal comes in a convenient pouch. This formula features highly digestible proteins to promote digestive health...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Wet Digest Sensitive Cat Food Pouch</strong> is formulated to support healthy digestion for your adult cat.</p><p>This complete and balanced meal comes in a convenient pouch. This formula features highly digestible proteins to promote digestive health and reduce stool odor for your indoor cat.</p><p><strong>Key Features:</strong></p><ul><li>Optimal Stool: Highly digestible proteins that help support healthy digestion also help reduce stool odor</li><li>Complete and Balanced: Soft cat food in easy-to-open pouch is 100% complete and balanced cat nutrition and pairs well with Royal Canin Dry Cat Food</li><li>Weight Management: High protein levels help support lean muscle and help cats maintain an ideal weight</li><li>Health &amp; Wellness: A precise blend of vitamins and minerals helps support overall cat health and wellness</li></ul></div>',
    keyBenefits: [
      'Optimal Stool: Highly digestible proteins that help support healthy digestion also help reduce stool odor',
      'Complete and Balanced: Soft cat food in easy-to-open pouch is 100% complete and balanced cat nutrition and pairs well with Royal Canin Dry Cat Food',
      'Weight Management: High protein levels help support lean muscle and help cats maintain an ideal weight',
      'Health & Wellness: A precise blend of vitamins and minerals helps support overall cat health and wellness',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'WET POUCHES ONLY PER DAY',
        overweight: 'WET + DRY FOOD PER DAY',
      },
      {
        weight: '3 kg',
        idealWeight: '2+1/4 pouches',
        overweight: '1 pouch + 26 g dry food',
      },
      {
        weight: '4 kg',
        idealWeight: '3 pouches',
        overweight: '1 pouch + 36 g dry food',
      },
      {
        weight: '5 kg',
        idealWeight: '3+1/4 pouches',
        overweight: '1 pouch + 45 g dry food',
      },
      {
        weight: '6 kg',
        idealWeight: '3+3/4 pouches',
        overweight: '1 pouch + 54 g dry food',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Pouch',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Maine_Coon_Wet_85g.jpg',
    id: 'RC_Maine_Coon_Wet_85g',
    name: 'Royal Canin Maine Coon Adult (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Maine Coon',
    needs: 'General',
    sterilised: 'No',
    productSize: '100g',
    description:
      'The Royal Canin Maine Coon Cat Food Pouches is specially for adult Maine Coon cats - Over 15 months old (thin slices in gravy).Contains a highly concentrated energy formula to provide your large cat with the energy levels it needs to complete its...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Maine Coon Cat Food Pouches</strong> is s<span>pecially for adult Maine Coon cats - Over 15 months old (thin slices in gravy).</span></p><p><span><span>Contains a highly concentrated energy formula to provide your large cat with the energy levels it needs to complete its daily routines.</span></span></p><p><strong>Key Features:</strong></p><ul><li><strong>Bone &amp; Joint Health - </strong>Enriched with Taurine, DHA and EPA (Omega-3 fatty acids) to help maintain muscle and bone strength.</li><li><strong>Adapted Texture - </strong>The soft texture of the loaf is also ideal to help ease chewing and support optimal consumption and digestion.</li><li><strong>Concentrated Energy - </strong>Contains a highly concentrated energy formula to provide your large cat with the energy levels it needs to complete its daily routines</li><li><strong>Coat &amp; Skin Health -</strong> Contains nutrients that help to provide the nourishment needed to maintain the good health of your Maine Coon’s skin and silky coat.</li></ul></div>',
    keyBenefits: [
      'Bone & Joint Health -',
      'Adapted Texture -',
      'Concentrated Energy -',
      'Coat & Skin Health -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '2 kg',
        idealWeight: '40g (4/8 cup)',
        overweight: '47 g (4/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '54 g (5/8cup)',
        overweight: '63 g (6/8 cup)',
      },
      {
        weight: '4 kg',
        idealWeight: '68 g (6/8 cup)',
        overweight: '78 g (7/8 cup)',
      },
      {
        weight: '5 kg',
        idealWeight: '80 g (7/8 cup)',
        overweight: '93 g (1 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '92 g (1 cup)',
        overweight: '106 g (1+1/8 cups)',
      },
      {
        weight: '7 kg',
        idealWeight: '103 g (1+1/8 cups)',
        overweight: '119 g (1+2/8 cups)',
      },
      {
        weight: '8 kg',
        idealWeight: '114 g (1+2/8 cups)',
        overweight: '132 g (1+4/8 cups)',
      },
      {
        weight: '9 kg',
        idealWeight: '124 g (1+3/8 cups)',
        overweight: '144 g (1+5/8 cups)',
      },
      {
        weight: '10 kg',
        idealWeight: '134 g (1+4/8 cups)',
        overweight: '156 g (1+6/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Joint Care, Pouch, Skin & Coat',
      breed: 'Maine Coon',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Senior_4kg.jpg',
    id: 'RC_Senior_Wet_85g',
    name: 'Royal Canin Ageing 11+ in Gravy (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '100g',
    description:
      'The Royal Canin Wet Ageing 12+ Cat Food Pouch is complete feed for senior cats over 12 years old (thin slices in gravy).This food contains highly palatable kibble with a double texture that helps to stimulate your senior cat’s general appetite.Key...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Wet Ageing 12+ Cat Food Pouch</strong> is c<span>omplete feed for senior cats over 12 years old (thin slices in gravy).</span></p><p>This food contains highly palatable kibble with a double texture that helps to stimulate your senior cat’s general appetite.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Joint Health - </strong>Enriched with EPA &amp; DHA to maintain healthy joints.</li><li><strong>Instinctively Preferred - </strong>Formulated to match the optimal macro nutritional profile instinctively preferred by adult cats.</li><li><strong><strong>Renal Health -</strong></strong> Helps support renal healthy function thanks to a moderate phosphorus level.</li></ul></div>',
    keyBenefits: [
      'Joint Health -',
      'Instinctively Preferred -',
      'Renal Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'WET POUCHES ONLY PER DAY',
        overweight: 'WET + DRY FOOD PER DAY',
      },
      {
        weight: '3 kg',
        idealWeight: '2 pouches',
        overweight: '1 pouch + 22 g dry food',
      },
      {
        weight: '4 kg',
        idealWeight: '2+1/2 pouches',
        overweight: '1 pouch + 31 g dry food',
      },
      {
        weight: '5 kg',
        idealWeight: '3 pouches',
        overweight: '1 pouch + 40 g dry food',
      },
      {
        weight: '6 kg',
        idealWeight: '3+1/2 pouches',
        overweight: '1 pouch + 49 g dry food',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Joint Care',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  // -- New Wet Food (from RC ZA) --
  {
    image: '/pet_images/RC_Mother_Babycat_Mousse_85g.jpg',
    id: 'RC_Mother_Babycat_Mousse_85g',
    name: 'Royal Canin Mother & Babycat Mousse (12x195g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2.34,
    price: 459,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '100g',
    description:
      'The Royal Canin Instinctive Babycat Canned Food is designed for kittens from 1 to 4 months. It is a unique ultra-soft mousse for weaning kittens under 4 months of age and is also ideal for gestating and lactating queens.It features the optimal...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Instinctive Babycat Canned Food</strong> is designed for kittens from 1 to 4 months. It is a unique ultra-soft mousse for weaning kittens under 4 months of age and is also ideal for gestating and lactating queens.</p><p>It features the optimal balance of proteins, fats and carbohydrates at this stage of a kitten\\\'s development. This helps to ensure a kitten enjoys its meal, and benefits from all of the nutrients included in the formula.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Age Easy Start - </strong>The "mousse" texture facilitates the easy transition to solid food.</li><li><strong>Instinctively Preferred - </strong>Prefferred by kittens and gestating queens due to its natritional profile.</li><li><strong>Immune System Support - </strong>Helps to support kittens\\\' natural defences.</li></ul></div>',
    keyBenefits: [
      'Age Easy Start -',
      'Instinctively Preferred -',
      'Immune System Support -',
    ],
    feedingGuide: [
      {
        weight: 'AGE (WEEKS)',
        idealWeight: 'CANS ONLY PER DAY',
        overweight: '1/2 CAN + DRY FOOD',
      },
      {
        weight: '4 weeks',
        idealWeight: 'Introduce food gradually',
        overweight: 'N/A',
      },
      {
        weight: '8 weeks',
        idealWeight: '3/4-1 cans',
        overweight: '1/2 can + 15-30 g dry food',
      },
      {
        weight: '12 weeks',
        idealWeight: '1-1 1/2 cans',
        overweight: '1/2 can + 25-45 g dry food',
      },
      {
        weight: '16 + weeks',
        idealWeight: '1 1/4-1 1/2 cans or transition to Royal Canin Kitten',
        overweight: '1/2 can + 30+50 g or transition to Royal Canin Kitten',
      },
      {
        weight: 'Adult lactating mother',
        idealWeight: 'Ad libitum',
        overweight: 'Ad libitum',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Can',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sensory_Feel_Wet_85g.jpg',
    id: 'RC_Sensory_Feel_Wet_85g',
    name: 'Royal Canin Sensory Feel (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '100g',
    description:
      'Royal Canin Sensory Feel Morsels in Gravy Cat Food Pouches - 12x85g the formula is crafted with unique textures to stimulate the Cat\'s sense of mouthfeel.Cats appreciate how their food feels THE RECEPTORS LOCATED IN CATS\' MOUTHS PLAY A PARTICULARLY...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Sensory Feel Morsels in Gravy Cat Food Pouches</strong> - 12x85g the formula is crafted with unique textures to stimulate the Cat\\\\\\\'s sense of mouthfeel. Cats appreciate how their food feels THE RECEPTORS LOCATED IN CATS\\\\\\\' MOUTHS PLAY A PARTICULARLY SIGNIFICANT SENSORY ROLE. This food sensory characteristic is known as mouthfeel, which can be defined as the perception of the physical texture of foods in the mouth, which play an undeniable role in the eating experience! <strong>Key Benefits:</strong></p><ul><li> Feel stimulation: Stimulates cats’ refined sense of unique textures.</li><li> Sensory stimulation: A cat’s well-being is enhanced when its diet provides sensorial variation. Royal Canin Sensory helps to stimulate cats’ senses and enhances their feeding experience.</li><li> Instinctively preferred: Formulated to match the optimal macronutrient profile instinctively preferred by adult cats.</li><li> Urinary health: Helps to support a healthy urinary system.</li></ul></div>',
    keyBenefits: [
      'Feel stimulation: Stimulates cats’ refined sense of unique textures.',
      'Sensory stimulation: A cat’s well-being is enhanced when its diet provides sensorial variation. Royal Canin Sensory helps to stimulate cats’ senses and enhances their feeding experience.',
      'Instinctively preferred: Formulated to match the optimal macronutrient profile instinctively preferred by adult cats.',
      'Urinary health: Helps to support a healthy urinary system.',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      barcode: '9003579018934',
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Gravy, Pouch, Wet Food',
      breed: 'Non-Specific',
      breed_size: 'All Breeds',
      flavour: 'No',
      lifestage: 'All',
      size: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sensory_Smell_Wet_85g.jpg',
    id: 'RC_Sensory_Smell_Wet_85g',
    name: 'Royal Canin Sensory Smell (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '100g',
    description:
      'Royal Canin Sensory Smell Morsels in Gravy Cat Food Pouches This formula is crafted with an attractive aromatic profile to stimulate cats’ olfactory senseCats appreciate how their food smells OLFACTION IS BY FAR THE MOST DEVELOPED SENSE IN THE CATA...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Sensory Smell Morsels in Gravy Cat Food Pouches</strong> This formula is crafted with an attractive aromatic profile to stimulate cats’ olfactory sense Cats appreciate how their food smells OLFACTION IS BY FAR THE MOST DEVELOPED SENSE IN THE CAT A cat possesses 200 million odour-sensitive cells in their nose (humans only have 5 million). Your cat’s first contact with food is through their nose, so their acceptance of food often relies greatly on its aroma <strong>Key Benefits:</strong></p><ul><li>Smell stimulation: Stimulates cats’ powerful sense of smell.</li></ul><ul><li>Sensory stimulation: A cat’s well-being is enhanced when their diet provides sensorial variation. Royal Canin Sensory helps to stimulate cats’ senses and enhances their feeding experience.</li><li>Instinctively preferred: Formulated to match the optimal macronutrient profile instinctively preferred by adult cats.</li><li>Urinary health: Helps to support a healthy urinary system."</li></ul></div>',
    keyBenefits: [
      'Smell stimulation: Stimulates cats’ powerful sense of smell.',
      'Sensory stimulation: A cat’s well-being is enhanced when their diet provides sensorial variation. Royal Canin Sensory helps to stimulate cats’ senses and enhances their feeding experience.',
      'Instinctively preferred: Formulated to match the optimal macronutrient profile instinctively preferred by adult cats.',
      'Urinary health: Helps to support a healthy urinary system."',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      barcode: '9003579018507',
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Gravy, Pouch, Wet Food',
      breed: 'Non-Specific',
      breed_size: 'All Breeds',
      flavour: 'No',
      lifestage: 'All',
      size: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sensory_Taste_Wet_85g.jpg',
    id: 'RC_Sensory_Taste_Wet_85g',
    name: 'Royal Canin Sensory Taste (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '100g',
    description:
      'Royal Canin Sensory Taste Morsels in Gravy Cat Food Pouches the formula is crafted with specific savoury flavours to stimulate cats\' sense of taste.Cats appreciate how their food tastes CATS ARE HIGHLY PERCEPTIVE OF SUBTLE FOOD FLAVOURSAlthough cats...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Sensory Taste Morsels in Gravy Cat Food Pouches</strong> the formula is crafted with specific savoury flavours to stimulate cats\\\\\\\' sense of taste. Cats appreciate how their food tastes CATS ARE HIGHLY PERCEPTIVE OF SUBTLE FOOD FLAVOURS Although cats have fewer taste buds and their sense of taste isn’t the strongest, it is still uniquely specialised. Because of their carnivorous predisposition, cats are sensitive to the meaty flavours associated with savouriness; so even though their taste range is smaller, they still have a perceptive sensitivity to taste <strong>Key Benefits:</strong></p><ul><li> Taste stimulation: Stimulates cats’ distinctive sense of taste.</li><li> Sensory stimulation: A cat’s well-being is enhanced when their diet provides sensorial variation. Royal Canin Sensory helps to stimulate cats’ senses and enhances their feeding experience.</li><li> Instinctively preferred: Formulated to match the optimal macronutrient profile instinctively preferred by adult cats.</li><li> Urinary health: Helps to support a healthy urinary system.</li></ul></div>',
    keyBenefits: [
      'Taste stimulation: Stimulates cats’ distinctive sense of taste.',
      'Sensory stimulation: A cat’s well-being is enhanced when their diet provides sensorial variation. Royal Canin Sensory helps to stimulate cats’ senses and enhances their feeding experience.',
      'Instinctively preferred: Formulated to match the optimal macronutrient profile instinctively preferred by adult cats.',
      'Urinary health: Helps to support a healthy urinary system.',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      barcode: '9003579018859',
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Gravy, Pouch, Wet Food',
      breed: 'Non-Specific',
      breed_size: 'All Breeds',
      flavour: 'No',
      lifestage: 'All',
      size: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Senior_4kg.jpg',
    id: 'RC_Senior_Instinctive_Wet_85g',
    name: 'Royal Canin Instinctive 7+ in Gravy (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '100g',
    description:
      'The Royal Canin Wet Instinctive 7+ Cat Food Pouch is designed for cats from 7 to 12 years.This formulas was created with the optimal balance between proteins, fats and carbohydrates to support long-term palatability and work as the perfect...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Wet Instinctive 7+ Cat Food Pouch</strong> is designed for cats from 7 to 12 years.</p><p>This formulas was created with the optimal balance between proteins, fats and carbohydrates to support long-term palatability and work as the perfect nutritional complement to our premium dry cat food.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Vitality Complex - </strong>Contains an exclusive antioxidant complex to help support vitality.</li><li><strong>Instinctively Preferred - </strong>Formulated to match the optimal macro nutritional profile instinctively preferred by adult cats.</li><li><strong>Renal Health - </strong>Adapted phosphorus content.</li></ul></div>',
    keyBenefits: [
      'Vitality Complex -',
      'Instinctively Preferred -',
      'Renal Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'WET POUCHES ONLY PER DAY',
        overweight: 'WET + DRY FOOD PER DAY',
      },
      {
        weight: '3 kg',
        idealWeight: '2+1/4 pouches',
        overweight: '1 pouch + 26 g dry food',
      },
      {
        weight: '4 kg',
        idealWeight: '3 pouches',
        overweight: '1 pouch + 36 g dry food',
      },
      {
        weight: '5 kg',
        idealWeight: '3+1/4 pouches',
        overweight: '1 pouch + 45 g dry food',
      },
      {
        weight: '6 kg',
        idealWeight: '3+3/4 pouches',
        overweight: '1 pouch + 54 g dry food',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Pouch',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Adult_Wet_85g.jpg',
    id: 'RC_Intense_Beauty_Wet_85g',
    name: 'Royal Canin Hair & Skin Chunks in Gravy (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '100g',
    description:
      'The Royal Canin Hair & Skin Cat Food Pouch is a complete and balanced nutrition to support your adult cat’s natural beauty. This exclusive soft cat food comes in a convenient pouch and is formulated with omega-3 and omega-6 fatty acids to support...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Hair &amp; Skin Cat Food Pouch</strong> is a complete and balanced nutrition to support your adult cat’s natural beauty. This exclusive soft cat food comes in a convenient pouch and is formulated with omega-3 and omega-6 fatty acids to support your cat’s shiny and soft coat.</p><p><strong>Key Benefits:</strong></p><ul><li>Nourishes a <strong>beautiful, shiny coat</strong> with optimal levels of omega-3 and omega-6 fatty acids.</li><li>100% complete and balanced <strong>easy-to-open pouch</strong> pairs well with Royal Canin Dry Cat Food.</li><li>Helps maintain an <strong>ideal weight</strong> with moderate calorie levels.</li><li>Promotes overall cat health and wellness with a precise balance of <strong>vitamins and minerals</strong></li></ul></div>',
    keyBenefits: [
      'Nourishes a',
      '100% complete and balanced',
      'Helps maintain an',
      'Promotes overall cat health and wellness with a precise balance of',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'WET FOOD ONLY',
        overweight: 'DRY & WET FOOD',
      },
      {
        weight: '3 kg',
        idealWeight: '2 pouches',
        overweight: '20 g + 1 pouch',
      },
      {
        weight: '4 kg',
        idealWeight: '2 + 1/2 pouches',
        overweight: '29 g + 1 pouch',
      },
      {
        weight: '5 kg',
        idealWeight: '2 + 3/4 pouches',
        overweight: '38 g + 1 pouch',
      },
      {
        weight: '6 kg',
        idealWeight: '3 + 1/4 pouches',
        overweight: '46 g + 1 pouch',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Skin & Coat, Urinary Care',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Kitten_Wet_85g.jpg',
    id: 'RC_Sterilised_Kitten_Wet_85g',
    name: 'Royal Canin Kitten Sterilised in Jelly (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'Sterilised',
    sterilised: 'Yes',
    productSize: '100g',
    description:
      'The Royal Canin Sterilised Kitten Food is specially for neutered kittens (from 6 to 12 months old).With nutrients included to help support your kitten’s natural defenses after being spayed or neutered, you can help maintain its health throughout its...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Sterilised Kitten Food</strong> is s<span>pecially for neutered kittens (from 6 to 12 months old).</span></p><p>With nutrients included to help support your kitten’s natural defenses after being spayed or neutered, you can help maintain its health throughout its second age life stage.</p><p><strong>Key Features:</strong></p><ul><li><strong>Growth &amp; Weight Control - </strong>After neutering energy needs change and the risk of becoming overweight increases. This diet is formulated with a moderate level of fat to limit any potential weight gain. </li><li><strong>Immune System Support - </strong>Premium formula designed to support your kitten’s natural defences during this essential growth stage.</li><li><strong>Urinary Health - </strong>Contains a combination of minerals that help maintain your adult cat\\\\\\\'s urinary system.</li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li></ul></div>',
    keyBenefits: [
      'Growth & Weight Control -',
      'Immune System Support -',
      'Urinary Health -',
      'Digestive Health -',
    ],
    feedingGuide: [
      {
        weight: 'KITTEN\'S AGE',
        idealWeight: '6 - 9 MONTHS',
        overweight: '10 - 12 MONTHS',
      },
      {
        weight: 'Kitten\'s weight',
        idealWeight: '2,4 - 4,5 kg',
        overweight: '2,9 - 5 kg',
      },
      {
        weight: 'Kibbles only',
        idealWeight: '70 - 100 g',
        overweight: '68 - 100 g',
      },
      {
        weight: 'Kibble + pouch "Royal Canin Kitten Sterilised"',
        idealWeight: '45 - 70 g + 1 pouch',
        overweight: '40 - 70 g + 1 pouch',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Digestive Care, Urinary Care, Weight Control',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Urinary_Wet_85g.jpg',
    id: 'RC_Light_Weight_Wet_85g',
    name: 'Royal Canin Light Weight Care Chunks in Gravy (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Weight care',
    sterilised: 'No',
    productSize: '100g',
    description:
      'The Royal Canin Wet Ultra Light Cat Food Pouch formula helps reduce the calorie intake of cats who have a tendency to gain weight.Royal Canin Ultra Light in Gravy helps reduce the calorie intake of cats by as much as 19% to help limit weight gain...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Wet Ultra Light Cat Food Pouch</strong> formula helps reduce the calorie intake of cats who have a tendency to gain weight.</p><p><span>Royal Canin Ultra Light in Gravy helps reduce the calorie intake of cats by as much as 19% to help limit weight gain and maintain a healthy weight bracket. The nutrients are also enriched with L-Carnitine to help support and stimulate a healthy and fast-acting metabolism.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Calorie Reduction - </strong>Enriched with L-carnitine which supports and stimulate a healthy and fast-acting metabolism.</li><li><strong>Muscle Mass - </strong>Formulated to have high protein content to maintain muscle tone.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Calorie Reduction -',
      'Muscle Mass -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT WEIGHT',
        idealWeight: 'POUCH',
        overweight: 'POUCH + KIBBLES (G)',
      },
      {
        weight: '4 kg',
        idealWeight: '3 + 1/2 Pouch',
        overweight: '1 Pouch + 44g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Pouch, Urinary Care, Weight Control',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  // -- New from 2026 Price List --
  {
    image: '/pet_images/RC_Mother_Babycat_400g.jpg',
    id: 'RC_Mother_Babycat_400g',
    name: 'Royal Canin Mother & Babycat (400g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 0.4,
    price: 90,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '101-400g',
    description:
      'The Royal Canin Instinctive Babycat Canned Food is designed for kittens from 1 to 4 months. It is a unique ultra-soft mousse for weaning kittens under 4 months of age and is also ideal for gestating and lactating queens.It features the optimal...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Instinctive Babycat Canned Food</strong> is designed for kittens from 1 to 4 months. It is a unique ultra-soft mousse for weaning kittens under 4 months of age and is also ideal for gestating and lactating queens.</p><p>It features the optimal balance of proteins, fats and carbohydrates at this stage of a kitten\\\'s development. This helps to ensure a kitten enjoys its meal, and benefits from all of the nutrients included in the formula.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Age Easy Start - </strong>The "mousse" texture facilitates the easy transition to solid food.</li><li><strong>Instinctively Preferred - </strong>Prefferred by kittens and gestating queens due to its natritional profile.</li><li><strong>Immune System Support - </strong>Helps to support kittens\\\' natural defences.</li></ul></div>',
    keyBenefits: [
      'Age Easy Start -',
      'Instinctively Preferred -',
      'Immune System Support -',
    ],
    feedingGuide: [
      {
        weight: 'AGE (WEEKS)',
        idealWeight: 'CANS ONLY PER DAY',
        overweight: '1/2 CAN + DRY FOOD',
      },
      {
        weight: '4 weeks',
        idealWeight: 'Introduce food gradually',
        overweight: 'N/A',
      },
      {
        weight: '8 weeks',
        idealWeight: '3/4-1 cans',
        overweight: '1/2 can + 15-30 g dry food',
      },
      {
        weight: '12 weeks',
        idealWeight: '1-1 1/2 cans',
        overweight: '1/2 can + 25-45 g dry food',
      },
      {
        weight: '16 + weeks',
        idealWeight: '1 1/4-1 1/2 cans or transition to Royal Canin Kitten',
        overweight: '1/2 can + 30+50 g or transition to Royal Canin Kitten',
      },
      {
        weight: 'Adult lactating mother',
        idealWeight: 'Ad libitum',
        overweight: 'Ad libitum',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Can',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Kitten_400g.jpg',
    id: 'RC_Kitten_400g',
    name: 'Royal Canin Kitten (400g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 0.4,
    price: 88,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '101-400g',
    description:
      'The Royal Canin Growth Kitten Food is designed for kittens from 4 to 12 months old. Your playful and affectionate kitten deserves the best nutrition during this time of big changes, discoveries and new encounters!Key Benefits:Digestive Health:...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Growth Kitten Food</strong> is designed for kittens from 4 to 12 months old. </p><p>Your playful and affectionate kitten deserves the best nutrition during this time of big changes, discoveries and new encounters!</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Digestive Health: </strong>Supports digestion and healthy balance of intestinal flora, during this essential growth period.</li><li><strong>Immune System Support : </strong>Premium formula designed to support your kitten’s natural defences during this essential growth stage.</li><li><strong>Healthy Growth :</strong> An adapted content of protein, vitamins and minerals including vitamin D and calcium helps support the development of the kitten’s bones and muscles.</li><li><span><strong>L.I.P</strong> : </span><span>Selected protein with digestibility over 90%</span></li></ul></div><p><span>To be stored in a cool, dry place.</span></p>',
    keyBenefits: [
      'Digestive Health:',
      'Immune System Support :',
      'Healthy Growth :',
      'L.I.P',
    ],
    feedingGuide: [
      {
        weight: 'KITTEN\'S AGE',
        idealWeight: 'KITTEN\'S WEIGHT',
        overweight: 'DRY FOOD ONLY',
      },
      {
        weight: '1 - 2 months',
        idealWeight: '0.4 - 1 kg',
        overweight: '29 - 48 g',
      },
      {
        weight: '3 - 4 months',
        idealWeight: '1.3 - 2 kg',
        overweight: '61 - 66 g',
      },
      {
        weight: '5 - 6 months',
        idealWeight: '2.3 - 2.9 kg',
        overweight: '69 - 67 g',
      },
      {
        weight: '7 - 12 months',
        idealWeight: '3.1 - 4 kg',
        overweight: '64 - 51 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Kitten_10kg.jpg',
    id: 'RC_Kitten_10kg',
    name: 'Royal Canin Kitten (10kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 10,
    price: 1232,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Growth Kitten Food is designed for kittens from 4 to 12 months old. Your playful and affectionate kitten deserves the best nutrition during this time of big changes, discoveries and new encounters!Key Benefits:Digestive Health:...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Growth Kitten Food</strong> is designed for kittens from 4 to 12 months old. </p><p>Your playful and affectionate kitten deserves the best nutrition during this time of big changes, discoveries and new encounters!</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Digestive Health: </strong>Supports digestion and healthy balance of intestinal flora, during this essential growth period.</li><li><strong>Immune System Support : </strong>Premium formula designed to support your kitten’s natural defences during this essential growth stage.</li><li><strong>Healthy Growth :</strong> An adapted content of protein, vitamins and minerals including vitamin D and calcium helps support the development of the kitten’s bones and muscles.</li><li><span><strong>L.I.P</strong> : </span><span>Selected protein with digestibility over 90%</span></li></ul></div><p><span>To be stored in a cool, dry place.</span></p>',
    keyBenefits: [
      'Digestive Health:',
      'Immune System Support :',
      'Healthy Growth :',
      'L.I.P',
    ],
    feedingGuide: [
      {
        weight: 'KITTEN\'S AGE',
        idealWeight: 'KITTEN\'S WEIGHT',
        overweight: 'DRY FOOD ONLY',
      },
      {
        weight: '1 - 2 months',
        idealWeight: '0.4 - 1 kg',
        overweight: '29 - 48 g',
      },
      {
        weight: '3 - 4 months',
        idealWeight: '1.3 - 2 kg',
        overweight: '61 - 66 g',
      },
      {
        weight: '5 - 6 months',
        idealWeight: '2.3 - 2.9 kg',
        overweight: '69 - 67 g',
      },
      {
        weight: '7 - 12 months',
        idealWeight: '3.1 - 4 kg',
        overweight: '64 - 51 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Fit_400g.jpg',
    id: 'RC_Fit_400g',
    name: 'Royal Canin Fit (400g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 0.4,
    price: 84,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '101-400g',
    description:
      'The Royal Canin Health Fit Cat Food is designed for active, adult cats with outdoor access, over 1 years old.Donut shaped kibble encourages chewing to help slow ingestion and has an adapted calorie content to help maintain the ideal weight of...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Fit Cat Food</strong> is designed for active, adult cats with outdoor access, over 1 years old.</p><p>Donut shaped kibble encourages chewing to help slow ingestion and has an adapted calorie content to help maintain the ideal weight of cats.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Optimal Nutrient Profile - </strong>Contains beneficial nutrition that is formulated to maintain good health in your adult cat.</li><li><strong>Healthy Weight - </strong>Adapted calorie content maintains an ideal weight of moderately active adult cats.</li><li><strong>Hairball Reduction - </strong>Specific fibre helps to stimulate intestinal transit and eliminate ingested hair. </li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Optimal Nutrient Profile -',
      'Healthy Weight -',
      'Hairball Reduction -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'IDEAL WEIGHT',
        overweight: 'OVERWEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '44 g (26g + 1 pouch)',
        overweight: '35 g (17 g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '54 g (36 g + 1 pouch)',
        overweight: '43 g (25 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '63 g (45 g + 1 pouch)',
        overweight: '51 g (39g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '72 g (54 g + 1 pouch)',
        overweight: '58 g (39g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Fit_15kg.jpg',
    id: 'RC_Fit_15kg',
    name: 'Royal Canin Fit (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1934,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin Health Fit Cat Food is designed for active, adult cats with outdoor access, over 1 years old.Donut shaped kibble encourages chewing to help slow ingestion and has an adapted calorie content to help maintain the ideal weight of...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Fit Cat Food</strong> is designed for active, adult cats with outdoor access, over 1 years old.</p><p>Donut shaped kibble encourages chewing to help slow ingestion and has an adapted calorie content to help maintain the ideal weight of cats.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Optimal Nutrient Profile - </strong>Contains beneficial nutrition that is formulated to maintain good health in your adult cat.</li><li><strong>Healthy Weight - </strong>Adapted calorie content maintains an ideal weight of moderately active adult cats.</li><li><strong>Hairball Reduction - </strong>Specific fibre helps to stimulate intestinal transit and eliminate ingested hair. </li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Optimal Nutrient Profile -',
      'Healthy Weight -',
      'Hairball Reduction -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'IDEAL WEIGHT',
        overweight: 'OVERWEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '44 g (26g + 1 pouch)',
        overweight: '35 g (17 g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '54 g (36 g + 1 pouch)',
        overweight: '43 g (25 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '63 g (45 g + 1 pouch)',
        overweight: '51 g (39g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '72 g (54 g + 1 pouch)',
        overweight: '58 g (39g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Savour_Exigent_400g.jpg',
    id: 'RC_Savour_Exigent_400g',
    name: 'Royal Canin Fussy (400g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 0.4,
    price: 101,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '101-400g',
    description:
      'The Royal Canin Health Exigent Cat Food is designed for adult cats who are sensitive to food texture, over 1 years old.Formulated for fussy eaters, Exigent is made with two differently shaped, textured and formulated kibbles to increase the appeal...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Exigent Cat Food</strong> is designed for adult cats who are sensitive to food texture, over 1 years old.</p><p>Formulated for fussy eaters, <strong>Exigent</strong> is made with two differently shaped, textured and formulated kibbles to increase the appeal of the food while it is in the cats mouth.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Dual Savour Sensation - </strong>Stimulates the natural preference of fussy eaters through two synergistic kibbles of different shape, composition and texture.</li><li><strong>Optimal Weight - </strong>Maintains an ideal weight for fussy cats through adapted energy content.</li><li><strong>Individual Preference - </strong>Royal Canin has developed three different formulas to satisfy even the fussiest cats.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Dual Savour Sensation -',
      'Optimal Weight -',
      'Individual Preference -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'UNDER WEIGHT',
        overweight: 'IDEAL WEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '51 g',
        overweight: '43 g',
      },
      {
        weight: '4 kg',
        idealWeight: '63 g',
        overweight: '53 g',
      },
      {
        weight: '5 kg',
        idealWeight: '74 g',
        overweight: '62 g',
      },
      {
        weight: '6 kg',
        idealWeight: '-',
        overweight: '70 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Weight Control',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Savour_Exigent_4kg.jpg',
    id: 'RC_Savour_Exigent_4kg',
    name: 'Royal Canin Fussy (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 706,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Health Exigent Cat Food is designed for adult cats who are sensitive to food texture, over 1 years old.Formulated for fussy eaters, Exigent is made with two differently shaped, textured and formulated kibbles to increase the appeal...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Exigent Cat Food</strong> is designed for adult cats who are sensitive to food texture, over 1 years old.</p><p>Formulated for fussy eaters, <strong>Exigent</strong> is made with two differently shaped, textured and formulated kibbles to increase the appeal of the food while it is in the cats mouth.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Dual Savour Sensation - </strong>Stimulates the natural preference of fussy eaters through two synergistic kibbles of different shape, composition and texture.</li><li><strong>Optimal Weight - </strong>Maintains an ideal weight for fussy cats through adapted energy content.</li><li><strong>Individual Preference - </strong>Royal Canin has developed three different formulas to satisfy even the fussiest cats.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Dual Savour Sensation -',
      'Optimal Weight -',
      'Individual Preference -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'UNDER WEIGHT',
        overweight: 'IDEAL WEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '51 g',
        overweight: '43 g',
      },
      {
        weight: '4 kg',
        idealWeight: '63 g',
        overweight: '53 g',
      },
      {
        weight: '5 kg',
        idealWeight: '74 g',
        overweight: '62 g',
      },
      {
        weight: '6 kg',
        idealWeight: '-',
        overweight: '70 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Weight Control',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Savour_Exigent_10kg.jpg',
    id: 'RC_Savour_Exigent_10kg',
    name: 'Royal Canin Fussy (10kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 10,
    price: 1444,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Health Exigent Cat Food is designed for adult cats who are sensitive to food texture, over 1 years old.Formulated for fussy eaters, Exigent is made with two differently shaped, textured and formulated kibbles to increase the appeal...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Health Exigent Cat Food</strong> is designed for adult cats who are sensitive to food texture, over 1 years old.</p><p>Formulated for fussy eaters, <strong>Exigent</strong> is made with two differently shaped, textured and formulated kibbles to increase the appeal of the food while it is in the cats mouth.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Dual Savour Sensation - </strong>Stimulates the natural preference of fussy eaters through two synergistic kibbles of different shape, composition and texture.</li><li><strong>Optimal Weight - </strong>Maintains an ideal weight for fussy cats through adapted energy content.</li><li><strong>Individual Preference - </strong>Royal Canin has developed three different formulas to satisfy even the fussiest cats.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Dual Savour Sensation -',
      'Optimal Weight -',
      'Individual Preference -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'UNDER WEIGHT',
        overweight: 'IDEAL WEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '51 g',
        overweight: '43 g',
      },
      {
        weight: '4 kg',
        idealWeight: '63 g',
        overweight: '53 g',
      },
      {
        weight: '5 kg',
        idealWeight: '74 g',
        overweight: '62 g',
      },
      {
        weight: '6 kg',
        idealWeight: '-',
        overweight: '70 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Weight Control',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sensible_400g.jpg',
    id: 'RC_Sensible_400g',
    name: 'Royal Canin Sensible (400g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 0.4,
    price: 101,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Digestive care',
    sterilised: 'No',
    productSize: '101-400g',
    description:
      'Complete feed for cats - For cats with digestive sensitivities, soft stools, or in need of support for optimal digestive health and balanced intestinal flora.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for cats - For cats with digestive sensitivities, soft stools, or in need of support for optimal digestive health and balanced intestinal flora.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Digestive Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Balanced Intestinal Flora - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Digestive Support -',
      'Balanced Intestinal Flora -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sensible_2kg.jpg',
    id: 'RC_Sensible_2kg',
    name: 'Royal Canin Sensible (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2,
    price: 412,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Digestive care',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for cats - For cats with digestive sensitivities, soft stools, or in need of support for optimal digestive health and balanced intestinal flora.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for cats - For cats with digestive sensitivities, soft stools, or in need of support for optimal digestive health and balanced intestinal flora.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Digestive Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Balanced Intestinal Flora - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Digestive Support -',
      'Balanced Intestinal Flora -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sensible_4kg.jpg',
    id: 'RC_Sensible_4kg',
    name: 'Royal Canin Sensible (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 706,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Digestive care',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for cats - For cats with digestive sensitivities, soft stools, or in need of support for optimal digestive health and balanced intestinal flora.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for cats - For cats with digestive sensitivities, soft stools, or in need of support for optimal digestive health and balanced intestinal flora.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Digestive Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Balanced Intestinal Flora - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Digestive Support -',
      'Balanced Intestinal Flora -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Sensible_15kg.jpg',
    id: 'RC_Sensible_15kg',
    name: 'Royal Canin Sensible (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 2193,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Digestive care',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for cats - For cats with digestive sensitivities, soft stools, or in need of support for optimal digestive health and balanced intestinal flora.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for cats - For cats with digestive sensitivities, soft stools, or in need of support for optimal digestive health and balanced intestinal flora.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Digestive Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Balanced Intestinal Flora - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Digestive Support -',
      'Balanced Intestinal Flora -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Ageing_12_plus_400g.jpg',
    id: 'RC_Ageing_12_plus_400g',
    name: 'Royal Canin Ageing 11+ (400g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 0.4,
    price: 102,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '101-400g',
    description:
      'The Royal Canin Health Ageing 12+ Cat Food is suitable for cats over 12 years of age and is specially formulated with the nutritional needs of senior cats like yours in mind. Royal Canin Senior Ageing 12+ helps to support healthy kidney function,...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>The Royal Canin Health Ageing 12+ Cat Food</strong> is suitable for cats over 12 years of age and is specially formulated with the nutritional needs of senior cats like yours in mind. Royal Canin Senior Ageing 12+ helps to support healthy kidney function, which is highly beneficial in senior cats.</p><p><strong>Key Features</strong></p><ul><li>Helps support renal healthy function thanks to a moderate phosphorus level.</li><li>Stimulate the senior cat’s appetite thanks to a highly palatable, double texture kibble which is easy to chew.</li><li>Contains specific nutrients to reduce consequences of ageing on cognitive function, mobility and oxidative stress</li><li>Contains a combination of minerals that help maintain your adult cat\\\\\\\'s urinary system.</li></ul></div>',
    keyBenefits: [
      'Helps support renal healthy function thanks to a moderate phosphorus level.',
      'Stimulate the senior cat’s appetite thanks to a highly palatable, double texture kibble which is easy to chew.',
      'Contains specific nutrients to reduce consequences of ageing on cognitive function, mobility and oxidative stress',
      'Contains a combination of minerals that help maintain your adult cat\'s urinary system.',
    ],
    feedingGuide: [
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Ageing',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Babycat_Milk_300g.jpg',
    id: 'RC_Babycat_Milk_300g',
    name: 'Royal Canin Babycat Milk (300g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 0.3,
    price: 362,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '101-400g',
    description:
      'Complete feed for cats - From birth to weanning.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for cats - From birth to weanning.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_British_Shorthair_Adult_4kg.jpg',
    id: 'RC_British_Shorthair_Adult_4kg',
    name: 'Royal Canin British Shorthair Adult (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 786,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'British Shorthair',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin British Shorthair Cat Food is designed exclusively for Pure Breed British Shorthair cats over 12 months old.The British Shorthair cat has a powerful and sturdy body with hardworking joints. Both a specific diet and adequate daily...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin British Shorthair Cat Food</strong> is designed exclusively for Pure Breed British Shorthair cats over 12 months old.</p><p>The British Shorthair cat has a powerful and sturdy body with hardworking joints. Both a specific diet and adequate daily rations are needed to promote a muscled body shape.</p><p><strong>Key Features:</strong></p><ul><li><strong>Special british shorthair jaw : </strong>This specially designed large curvy-shaped kibble is adapted to the British Shorthair cat’s broad jaw. The unique kibble facilitates grasping and encourages chewing to help support oral hygiene.</li><li><strong>Muscle tone : </strong>The British Shorthair cat has a sturdy, heavy and muscular body. An adapted level of protein contributes to maintaining muscle mass.</li><li><strong>L-Carnitine : </strong>Enriched with L-carnitine, involved in healthy fat metabolism.</li><li><strong>Bone &amp; joint health : </strong>Formulated to support healthy bones and joints. Enriched with Omega 3 fatty acids.</li><li><strong>Cardiac health : </strong>Enriched with nutrients such as taurine, EPA and DHA to help maintain healthy cardiac function.</li><li><strong>Urinary health : </strong>Formulated with a balance of minerals to help maintain the health of an adult cat’s urinary system.</li><li><strong>Charming chubby-face : </strong>Full broad chest, short, dense and plush coat, broad and round face</li></ul></div>',
    keyBenefits: [
      'Special british shorthair jaw :',
      'Muscle tone :',
      'L-Carnitine :',
      'Bone & joint health :',
      'Cardiac health :',
      'Urinary health :',
      'Charming chubby-face :',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'LOW ENERGY NEEDS',
        overweight: 'MODERATE / ACTIVE ENERGY NEEDS',
      },
      {
        weight: '3 to 4 kg',
        idealWeight: '34 -41 g (15 - 23 g + 1 pouch)',
        overweight: '42 - 52 g (24 - 33 g + 1 pouch)',
      },
      {
        weight: '5 to 6 kg',
        idealWeight: '49 - 55 g (30 - 37 g + 1 pouch)',
        overweight: '61 - 69 g (42 - 51 g + 1 pouch)',
      },
      {
        weight: '7 to 8 kg',
        idealWeight: '62 - 68 g (43 - 49 g + 1 pouch)',
        overweight: '77 - 85 g (59 - 66 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'British Shorthair',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Persian_Kitten_4kg.jpg',
    id: 'RC_Persian_Kitten_4kg',
    name: 'Royal Canin Persian Kitten (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 748,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: 'Persian',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Persian Kitten Food is designed exclusively for pedigreed Persian Kittens up to 12 months.Royal Canin Persian Kitten is formulated with highly digestible protein that\'s of the highest quality. It also contains an adapted fibre...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Persian Kitten Food</strong> is designed exclusively for pedigreed Persian Kittens up to 12 months.</p><p><span>Royal Canin Persian Kitten is formulated with highly digestible protein that\\\'s of the highest quality. It also contains an adapted fibre content and prebiotics to help support a good balance in the intestinal flora.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong><span>Exclusive formula - omega 3 &amp; omega 6 fatty acids : </span></strong>Exclusive formula - Omega 3 &amp; Omega 6 fatty acids.</li><li><strong>Miniature splendour :&amp;nbsp</strong><span>Long and thick coat Open sweet expression Cobby body.</span></li><li><strong>Digestive Health : </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Immune System Support : </strong>Premium formula designed to support your kitten’s natural defences during this essential growth stage.</li><li><strong>Exclusive Kibble Design : </strong>Exclusive rectangular kibble with soft texture, designed for the shortened jaw of a Persian kitten, also promotes oral health.</li><li><strong>Healthy growth &amp; long hair :</strong><span>During growth, the Persian kitten develops a long, dense and silky coat, the hallmark of the breed. </span></li></ul></div>',
    keyBenefits: [
      'Exclusive formula - omega 3 & omega 6 fatty acids :',
      'Miniature splendour :&nbsp',
      'Digestive Health :',
      'Immune System Support :',
      'Exclusive Kibble Design :',
      'Healthy growth & long hair :',
    ],
    feedingGuide: [
      {
        weight: 'KITTEN\'S AGE',
        idealWeight: '2 TO 3 MONTHS',
        overweight: '4 TO 6 MONTHS',
      },
      {
        weight: 'Weight',
        idealWeight: '0.8 kg - 2.1 kg',
        overweight: '1.8 kg - 3.9 kg',
      },
      {
        weight: 'Daily quantities (kibbles)',
        idealWeight: '40 - 69 g',
        overweight: '55 - 77 g',
      },
      {
        weight: 'Daily quantities (kibbles and pouch)',
        idealWeight: '16 - 45 g',
        overweight: '34 - 56 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Persian',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Persian_Adult_4kg.jpg',
    id: 'RC_Persian_Adult_4kg',
    name: 'Royal Canin Persian Adult (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 786,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Persian',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Persian Cat Food is designed exclusively for Pure Breed Persian cats over 12 months.This dignified breed is known for being quiet and sweet. Despite their docile nature, they need nutrition that is specifically designed to support...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Persian Cat Food</strong> is designed exclusively for Pure Breed Persian cats over 12 months.</p><p>This <span>dignified breed</span><span> is known for being quiet and sweet. Despite their docile nature, they need nutrition that is specifically designed to support their playful and curious lifestyle.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong><strong><span>Exclusive Kibble Design - </span></strong></strong>Exclusive almond-shaped kibble is designed with an optimal contact surface area is easy for the Persian cat to pick up and chew.</li><li><strong>Healthy Coat -</strong> Contains nutrients that help to support the skin\\\'s "barrier role" and maintain skin health &amp; coat beauty (EPA &amp; DHA). </li><li><strong>Hairball Reduction -</strong> A specific blend of fibres helps to naturally stimulate intestinal transit, eliminate ingested hair and control hairball formation.</li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design -',
      'Healthy Coat -',
      'Hairball Reduction -',
      'Digestive Health -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'LOW ENERGY NEEDS',
        overweight: 'MODERATE / ACTIVE ENERGY NEEDS',
      },
      {
        weight: '3 kg',
        idealWeight: '33 g (11 g + 1 pouch)',
        overweight: '41 g (19 g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '40 g (18 g + 1 pouch)',
        overweight: '50 g (29 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '47 g (25 g + 1 pouch)',
        overweight: '59 g (37 g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '54 g (32 g + 1 pouch)',
        overweight: '67 g (45 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Persian',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Persian_Adult_10kg.jpg',
    id: 'RC_Persian_Adult_10kg',
    name: 'Royal Canin Persian Adult (10kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 10,
    price: 1649,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Persian',
    needs: 'General',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Persian Cat Food is designed exclusively for Pure Breed Persian cats over 12 months.This dignified breed is known for being quiet and sweet. Despite their docile nature, they need nutrition that is specifically designed to support...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Persian Cat Food</strong> is designed exclusively for Pure Breed Persian cats over 12 months.</p><p>This <span>dignified breed</span><span> is known for being quiet and sweet. Despite their docile nature, they need nutrition that is specifically designed to support their playful and curious lifestyle.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong><strong><span>Exclusive Kibble Design - </span></strong></strong>Exclusive almond-shaped kibble is designed with an optimal contact surface area is easy for the Persian cat to pick up and chew.</li><li><strong>Healthy Coat -</strong> Contains nutrients that help to support the skin\\\'s "barrier role" and maintain skin health &amp; coat beauty (EPA &amp; DHA). </li><li><strong>Hairball Reduction -</strong> A specific blend of fibres helps to naturally stimulate intestinal transit, eliminate ingested hair and control hairball formation.</li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design -',
      'Healthy Coat -',
      'Hairball Reduction -',
      'Digestive Health -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'LOW ENERGY NEEDS',
        overweight: 'MODERATE / ACTIVE ENERGY NEEDS',
      },
      {
        weight: '3 kg',
        idealWeight: '33 g (11 g + 1 pouch)',
        overweight: '41 g (19 g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '40 g (18 g + 1 pouch)',
        overweight: '50 g (29 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '47 g (25 g + 1 pouch)',
        overweight: '59 g (37 g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '54 g (32 g + 1 pouch)',
        overweight: '67 g (45 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Persian',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Siamese_Adult_4kg.jpg',
    id: 'RC_Siamese_Adult_4kg',
    name: 'Royal Canin Siamese Adult (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 786,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Siamese',
    needs: 'General',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Siamese Cat Food is designed exclusively for pure breed Siamese cats over 12 months.Royal Canin Siamese Adult food has an increased level of protein and a moderate fat level to help preserve your cat\'s long, slender and muscular body...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Siamese Cat Food</strong> is designed exclusively for pure breed Siamese cats over 12 months.</p><p><span>Royal Canin Siamese Adult food has an increased level of protein and a moderate fat level to help preserve your cat\\\'s long, slender and muscular body type.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Exclusive Kibble Design - </strong>Exclusive tailor-made kibble is adapted to your Siamese\\\'s narrow and long muzzle. Designed to encourage chewing to help reduce the rate of food intake.</li><li><strong>Exclusive Formula - </strong>Enriched with 6 fatty acids and L-carnitine, both involved in healthy fat metabolism.</li><li><strong>Muscle Tone - </strong>Siamese cats typically have an elegant and athletic silhouette. The precise protein content and moderate fat levels helps to maintain their muscular body. </li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora. </li><li><strong>Healthy glossy coat - </strong>Combination of specific nutrients help to maintain healthy skin and shiny coat.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design -',
      'Exclusive Formula -',
      'Muscle Tone -',
      'Digestive Health -',
      'Healthy glossy coat -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'LOW ENERGY NEEDS',
        overweight: 'MODERATE / ACTIVE ENERGY NEEDS',
      },
      {
        weight: '3 kg',
        idealWeight: '33 g (12 g + 1 pouch)',
        overweight: '42 g (21 g + 1 pouch)',
      },
      {
        weight: '4 kg',
        idealWeight: '41 g (20 g + 1 pouch)',
        overweight: '51 g (30 g + 1 pouch)',
      },
      {
        weight: '5 kg',
        idealWeight: '48 g (27 g + 1 pouch)',
        overweight: '60 g (39 g + 1 pouch)',
      },
      {
        weight: '6 kg',
        idealWeight: '55 g (34 g + 1 pouch)',
        overweight: '68 g (47 g + 1 pouch)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Siamese',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Hair_Skin_Care_4kg.jpg',
    id: 'RC_Hair_Skin_Care_4kg',
    name: 'Royal Canin Hair & Skin Care (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 782,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Sensitive skin',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Feline Hair & Skin Care Cat Food is a balanced and complete feed for adult cats, recommended to support healthy skin and coat. It is an exclusive complex of nutrients that help to support the skin\'s barrier role. It contains high quality...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Feline Hair &amp; Skin Care Cat Food</strong> is a balanced and complete feed for adult cats, recommended to support healthy skin and coat.</p><p><span>It is an exclusive complex of nutrients that help to support the skin\\\\\\\'s barrier role. It contains high quality proteins, including specific amino acids, to maintain healthy hair growth and skin renewal.</span></p><p><strong>Benefits:</strong></p><ul><li>Includes B Vitamins: helps support the skin\\\\\\\'s role as a protective barrier</li><li>High quality proteins: very high digestibility for digestive health and stool quality</li><li>Omega 3 and Omega 6 fatty acids: beneficial effects on skin health and coat condition.</li></ul></div>',
    keyBenefits: [
      'Includes B Vitamins: helps support the skin\'s role as a protective barrier',
      'High quality proteins: very high digestibility for digestive health and stool quality',
      'Omega 3 and Omega 6 fatty acids: beneficial effects on skin health and coat condition.',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'IDEAL WEIGHT (G/DAY)',
        overweight: 'OVERWEIGHT (G/DAY)',
      },
      {
        weight: '3 kg',
        idealWeight: '45 g',
        overweight: '36 g',
      },
      {
        weight: '4 kg',
        idealWeight: '55 g',
        overweight: '44 g',
      },
      {
        weight: '5 kg',
        idealWeight: '65 g',
        overweight: '52 g',
      },
      {
        weight: '6 kg',
        idealWeight: '74 g',
        overweight: '59 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food, Skin & Coat',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Light_Weight_Care_1_5kg.jpg',
    id: 'RC_Light_Weight_Care_1_5kg',
    name: 'Royal Canin Light Weight Care (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 339,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Weight care',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Feline Light Weight Care Cat Food is a balanced and complete feed for adult cats - Recommended to help limit weight gain.Royal Canin Weight Care is enriched with L-Carnitine to maintain a healthy fat metabolism. It contains a high...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Feline Light Weight Care Cat Food</strong> is a b<span>alanced and complete feed for adult cats - Recommended to help limit weight gain.</span></p><p><span>Royal Canin Weight Care is enriched with L-Carnitine to maintain a healthy fat metabolism. It contains a high protein content and a low fat content; the perfect ratio for maintaining muscle mass whilst limiting weight gain.</span></p><p><strong>Key Features:</strong></p><ul><li>H<strong>igh protein and</strong> a <strong>low-fat content :</strong> The perfect ratio for maintaining muscle mass whilst limiting weight gain.</li><li><strong>Proven Results : </strong>A study done by Royal Canin found that over 90% of overweight cats achieved a healthier weight in 8 weeks, when fed this diet.</li><li><strong>Urinary Health : </strong>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</li></ul></div>',
    keyBenefits: [
      'H',
      'Proven Results :',
      'Urinary Health :',
    ],
    feedingGuide: [
      {
        weight: 'CAT WEIGHT',
        idealWeight: 'IDEAL WEIGHT',
        overweight: '-',
      },
      {
        weight: '-',
        idealWeight: 'Kibbles (Gram)',
        overweight: 'Kibbles (Gram) + 1 pouch',
      },
      {
        weight: '3kg',
        idealWeight: '51g',
        overweight: '31g + 1 pouch',
      },
      {
        weight: '4kg',
        idealWeight: '62g',
        overweight: '43g + 1 pouch',
      },
      {
        weight: '5kg',
        idealWeight: '73g',
        overweight: '54g + 1 pouch',
      },
      {
        weight: '6kg',
        idealWeight: '83g',
        overweight: '64g + 1 pouch',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food, Weight Control',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Light_Weight_Care_3kg.jpg',
    id: 'RC_Light_Weight_Care_3kg',
    name: 'Royal Canin Light Weight Care (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 544,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Weight care',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Feline Light Weight Care Cat Food is a balanced and complete feed for adult cats - Recommended to help limit weight gain.Royal Canin Weight Care is enriched with L-Carnitine to maintain a healthy fat metabolism. It contains a high...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Feline Light Weight Care Cat Food</strong> is a b<span>alanced and complete feed for adult cats - Recommended to help limit weight gain.</span></p><p><span>Royal Canin Weight Care is enriched with L-Carnitine to maintain a healthy fat metabolism. It contains a high protein content and a low fat content; the perfect ratio for maintaining muscle mass whilst limiting weight gain.</span></p><p><strong>Key Features:</strong></p><ul><li>H<strong>igh protein and</strong> a <strong>low-fat content :</strong> The perfect ratio for maintaining muscle mass whilst limiting weight gain.</li><li><strong>Proven Results : </strong>A study done by Royal Canin found that over 90% of overweight cats achieved a healthier weight in 8 weeks, when fed this diet.</li><li><strong>Urinary Health : </strong>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</li></ul></div>',
    keyBenefits: [
      'H',
      'Proven Results :',
      'Urinary Health :',
    ],
    feedingGuide: [
      {
        weight: 'CAT WEIGHT',
        idealWeight: 'IDEAL WEIGHT',
        overweight: '-',
      },
      {
        weight: '-',
        idealWeight: 'Kibbles (Gram)',
        overweight: 'Kibbles (Gram) + 1 pouch',
      },
      {
        weight: '3kg',
        idealWeight: '51g',
        overweight: '31g + 1 pouch',
      },
      {
        weight: '4kg',
        idealWeight: '62g',
        overweight: '43g + 1 pouch',
      },
      {
        weight: '5kg',
        idealWeight: '73g',
        overweight: '54g + 1 pouch',
      },
      {
        weight: '6kg',
        idealWeight: '83g',
        overweight: '64g + 1 pouch',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food, Weight Control',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Dental_Care_1_5kg.jpg',
    id: 'RC_Dental_Care_1_5kg',
    name: 'Royal Canin Dental Care (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 339,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Dental',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Feline Oral Care Cat Food is made to help reduce risk of dental plaque formation and tartar build-up..This targeted diet is formulated to support your cat’s oral health, keeping plaque and tartar in check.Key Features:Proven Results...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Feline Oral Care Cat Food</strong> is made <span>to help reduce risk of dental plaque formation and tartar build-up.</span>.</p><p>This targeted diet is formulated to support your cat’s oral health, keeping plaque and tartar in check.</p><p><strong>Key Features:</strong></p><ul><li><strong>Proven Results -</strong> Reduces the formation of dental plaque by 59% after 28 days of exclusive use*</li><li><strong>Oral Care - </strong>Exclusive cat kibble texture simulates a tooth-brushing effect that reduces plaque formation on teeth as they chew</li><li><strong>Prevents Tartar Build-up - </strong>Reduce tartar formation thanks to calcium chelators.</li><li><strong>Urinary Health - </strong>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</li></ul></div>',
    keyBenefits: [
      'Proven Results -',
      'Oral Care -',
      'Prevents Tartar Build-up -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT',
        idealWeight: 'UNDER WEIGHT',
        overweight: 'OVER WEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '47 g',
        overweight: '37 g',
      },
      {
        weight: '4 kg',
        idealWeight: '57 g',
        overweight: '46 g',
      },
      {
        weight: '5 kg',
        idealWeight: '67 g',
        overweight: '54 g',
      },
      {
        weight: '6 kg',
        idealWeight: '77 g',
        overweight: '61 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dental Care',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Dental_Care_3_5kg.jpg',
    id: 'RC_Dental_Care_3_5kg',
    name: 'Royal Canin Dental Care (3.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.5,
    price: 646,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Dental',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Feline Oral Care Cat Food is made to help reduce risk of dental plaque formation and tartar build-up..This targeted diet is formulated to support your cat’s oral health, keeping plaque and tartar in check.Key Features:Proven Results...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Feline Oral Care Cat Food</strong> is made <span>to help reduce risk of dental plaque formation and tartar build-up.</span>.</p><p>This targeted diet is formulated to support your cat’s oral health, keeping plaque and tartar in check.</p><p><strong>Key Features:</strong></p><ul><li><strong>Proven Results -</strong> Reduces the formation of dental plaque by 59% after 28 days of exclusive use*</li><li><strong>Oral Care - </strong>Exclusive cat kibble texture simulates a tooth-brushing effect that reduces plaque formation on teeth as they chew</li><li><strong>Prevents Tartar Build-up - </strong>Reduce tartar formation thanks to calcium chelators.</li><li><strong>Urinary Health - </strong>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</li></ul></div>',
    keyBenefits: [
      'Proven Results -',
      'Oral Care -',
      'Prevents Tartar Build-up -',
      'Urinary Health -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT',
        idealWeight: 'UNDER WEIGHT',
        overweight: 'OVER WEIGHT',
      },
      {
        weight: '3 kg',
        idealWeight: '47 g',
        overweight: '37 g',
      },
      {
        weight: '4 kg',
        idealWeight: '57 g',
        overweight: '46 g',
      },
      {
        weight: '5 kg',
        idealWeight: '67 g',
        overweight: '54 g',
      },
      {
        weight: '6 kg',
        idealWeight: '77 g',
        overweight: '61 g',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dental Care',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  // -- Added 2026 Wet Pouches --
  {
    image: '/pet_images/RC_Instinctive_Jelly_Wet_85g.jpg',
    id: 'RC_Instinctive_Jelly_Wet_85g',
    name: 'Royal Canin Instinctive in Jelly (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    sterilised: 'No',
    productSize: '100g',
    description:
      'The Royal Canin Wet Instinctive Chunks in Jelly Cat Food Pouch is a complete feed for adult cats (thin slices in gravy).With carefully selected nutrients included for optimal palatability, the end product is a dish that your cat simply won\'t be able...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Wet Instinctive Chunks in Jelly Cat Food Pouch</strong> is a c<span>omplete feed for adult cats (thin slices in gravy).</span></p><p><span>With carefully selected nutrients included for optimal palatability, the end product is a dish that your cat simply won\\\'t be able to resist. </span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Instinctively Preferred - </strong>Formulated to match the optimal macro nutritional profile instinctively preferred by adult cats.</li><li><strong><span>Urinary Health - </span></strong><span>Contains a combination of minerals that help maintain your adult cat\\\'s urinary system.</span></li><li><strong>Maintains Ideal Weight -</strong><span>Maintains an ideal weight through adapted energy content.</span></li></ul></div>',
    keyBenefits: [
      'Instinctively Preferred -',
      'Urinary Health -',
      'Maintains Ideal Weight -',
    ],
    feedingGuide: [
      {
        weight: 'CAT\'S WEIGHT',
        idealWeight: 'WET POUCHES ONLY PER DAY',
        overweight: 'WET + DRY FOOD PER DAY',
      },
      {
        weight: '3 kg',
        idealWeight: '2.5',
        overweight: '1 pouch + 20-25 g dry food',
      },
      {
        weight: '4 kg',
        idealWeight: '3',
        overweight: '1 pouch + 35-40 g dry food',
      },
      {
        weight: '5 kg',
        idealWeight: '3.5',
        overweight: '1 pouch + 40-45 g dry food',
      },
      {
        weight: '6 kg',
        idealWeight: '4',
        overweight: '1 pouch + 45-55 g dry food',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Wet Food',
      product_feature: 'Jelly, Pouch',
      breed: 'No',
      breed_size: 'All Breeds',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Kitten_Wet_85g.jpg',
    id: 'RC_Kitten_Sterilised_Wet_Gravy_85g',
    name: 'Royal Canin Kitten Sterilised in Gravy (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 254,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Kitten',
    breed: '',
    needs: 'Sterilised',
    sterilised: 'Yes',
    productSize: '100g',
    description:
      'The Royal Canin Sterilised Kitten Food is specially for neutered kittens (from 6 to 12 months old).With nutrients included to help support your kitten’s natural defenses after being spayed or neutered, you can help maintain its health throughout its...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Sterilised Kitten Food</strong> is s<span>pecially for neutered kittens (from 6 to 12 months old).</span></p><p>With nutrients included to help support your kitten’s natural defenses after being spayed or neutered, you can help maintain its health throughout its second age life stage.</p><p><strong>Key Features:</strong></p><ul><li><strong>Growth &amp; Weight Control - </strong>After neutering energy needs change and the risk of becoming overweight increases. This diet is formulated with a moderate level of fat to limit any potential weight gain. </li><li><strong>Immune System Support - </strong>Premium formula designed to support your kitten’s natural defences during this essential growth stage.</li><li><strong>Urinary Health - </strong>Contains a combination of minerals that help maintain your adult cat\\\\\\\'s urinary system.</li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li></ul></div>',
    keyBenefits: [
      'Growth & Weight Control -',
      'Immune System Support -',
      'Urinary Health -',
      'Digestive Health -',
    ],
    feedingGuide: [
      {
        weight: 'KITTEN\'S AGE',
        idealWeight: '6 - 9 MONTHS',
        overweight: '10 - 12 MONTHS',
      },
      {
        weight: 'Kitten\'s weight',
        idealWeight: '2,4 - 4,5 kg',
        overweight: '2,9 - 5 kg',
      },
      {
        weight: 'Kibbles only',
        idealWeight: '70 - 100 g',
        overweight: '68 - 100 g',
      },
      {
        weight: 'Kibble + pouch "Royal Canin Kitten Sterilised"',
        idealWeight: '45 - 70 g + 1 pouch',
        overweight: '40 - 70 g + 1 pouch',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Gravy, Pouch',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Kitten',
      size_chart: 'No',
    },
  },
];

export { royalcaninCatProducts };